var cov_2kh2svqu60 = function () {
  var path = '/opt/tomcat/.jenkins/workspace/delta-bitbucket-production/client/src/app/views/project/dashboard/projectDashboardCtrl.js',
      hash = 'c756306ceeb6deb2b8b22cac5be076df79f132da',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/opt/tomcat/.jenkins/workspace/delta-bitbucket-production/client/src/app/views/project/dashboard/projectDashboardCtrl.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 717,
          column: 3
        }
      },
      '1': {
        start: {
          line: 2,
          column: 15
        },
        end: {
          line: 2,
          column: 26
        }
      },
      '2': {
        start: {
          line: 3,
          column: 23
        },
        end: {
          line: 3,
          column: 31
        }
      },
      '3': {
        start: {
          line: 4,
          column: 25
        },
        end: {
          line: 4,
          column: 38
        }
      },
      '4': {
        start: {
          line: 5,
          column: 26
        },
        end: {
          line: 5,
          column: 39
        }
      },
      '5': {
        start: {
          line: 6,
          column: 24
        },
        end: {
          line: 6,
          column: 35
        }
      },
      '6': {
        start: {
          line: 7,
          column: 27
        },
        end: {
          line: 7,
          column: 40
        }
      },
      '7': {
        start: {
          line: 8,
          column: 33
        },
        end: {
          line: 8,
          column: 52
        }
      },
      '8': {
        start: {
          line: 9,
          column: 20
        },
        end: {
          line: 9,
          column: 26
        }
      },
      '9': {
        start: {
          line: 12,
          column: 20
        },
        end: {
          line: 12,
          column: 46
        }
      },
      '10': {
        start: {
          line: 14,
          column: 2
        },
        end: {
          line: 16,
          column: 4
        }
      },
      '11': {
        start: {
          line: 18,
          column: 2
        },
        end: {
          line: 21,
          column: 4
        }
      },
      '12': {
        start: {
          line: 19,
          column: 19
        },
        end: {
          line: 19,
          column: 50
        }
      },
      '13': {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 37
        }
      },
      '14': {
        start: {
          line: 23,
          column: 2
        },
        end: {
          line: 27,
          column: 4
        }
      },
      '15': {
        start: {
          line: 29,
          column: 2
        },
        end: {
          line: 33,
          column: 4
        }
      },
      '16': {
        start: {
          line: 35,
          column: 2
        },
        end: {
          line: 37,
          column: 4
        }
      },
      '17': {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 36,
          column: 16
        }
      },
      '18': {
        start: {
          line: 38,
          column: 2
        },
        end: {
          line: 52,
          column: 4
        }
      },
      '19': {
        start: {
          line: 39,
          column: 15
        },
        end: {
          line: 39,
          column: 17
        }
      },
      '20': {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 43,
          column: 5
        }
      },
      '21': {
        start: {
          line: 41,
          column: 6
        },
        end: {
          line: 41,
          column: 45
        }
      },
      '22': {
        start: {
          line: 42,
          column: 6
        },
        end: {
          line: 42,
          column: 35
        }
      },
      '23': {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 44,
          column: 43
        }
      },
      '24': {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 47,
          column: 5
        }
      },
      '25': {
        start: {
          line: 46,
          column: 6
        },
        end: {
          line: 46,
          column: 45
        }
      },
      '26': {
        start: {
          line: 49,
          column: 19
        },
        end: {
          line: 49,
          column: 59
        }
      },
      '27': {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 51,
          column: 47
        }
      },
      '28': {
        start: {
          line: 54,
          column: 2
        },
        end: {
          line: 76,
          column: 5
        }
      },
      '29': {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 58,
          column: 5
        }
      },
      '30': {
        start: {
          line: 56,
          column: 6
        },
        end: {
          line: 56,
          column: 29
        }
      },
      '31': {
        start: {
          line: 57,
          column: 6
        },
        end: {
          line: 57,
          column: 13
        }
      },
      '32': {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 75,
          column: 5
        }
      },
      '33': {
        start: {
          line: 60,
          column: 6
        },
        end: {
          line: 62,
          column: 7
        }
      },
      '34': {
        start: {
          line: 61,
          column: 8
        },
        end: {
          line: 61,
          column: 17
        }
      },
      '35': {
        start: {
          line: 63,
          column: 6
        },
        end: {
          line: 63,
          column: 70
        }
      },
      '36': {
        start: {
          line: 64,
          column: 6
        },
        end: {
          line: 64,
          column: 46
        }
      },
      '37': {
        start: {
          line: 65,
          column: 6
        },
        end: {
          line: 65,
          column: 74
        }
      },
      '38': {
        start: {
          line: 66,
          column: 6
        },
        end: {
          line: 66,
          column: 70
        }
      },
      '39': {
        start: {
          line: 67,
          column: 6
        },
        end: {
          line: 67,
          column: 75
        }
      },
      '40': {
        start: {
          line: 68,
          column: 6
        },
        end: {
          line: 68,
          column: 62
        }
      },
      '41': {
        start: {
          line: 69,
          column: 19
        },
        end: {
          line: 69,
          column: 21
        }
      },
      '42': {
        start: {
          line: 70,
          column: 6
        },
        end: {
          line: 72,
          column: 7
        }
      },
      '43': {
        start: {
          line: 71,
          column: 8
        },
        end: {
          line: 71,
          column: 47
        }
      },
      '44': {
        start: {
          line: 73,
          column: 6
        },
        end: {
          line: 73,
          column: 48
        }
      },
      '45': {
        start: {
          line: 74,
          column: 6
        },
        end: {
          line: 74,
          column: 37
        }
      },
      '46': {
        start: {
          line: 79,
          column: 2
        },
        end: {
          line: 135,
          column: 5
        }
      },
      '47': {
        start: {
          line: 80,
          column: 4
        },
        end: {
          line: 85,
          column: 7
        }
      },
      '48': {
        start: {
          line: 81,
          column: 6
        },
        end: {
          line: 81,
          column: 57
        }
      },
      '49': {
        start: {
          line: 82,
          column: 6
        },
        end: {
          line: 82,
          column: 63
        }
      },
      '50': {
        start: {
          line: 83,
          column: 6
        },
        end: {
          line: 83,
          column: 53
        }
      },
      '51': {
        start: {
          line: 84,
          column: 6
        },
        end: {
          line: 84,
          column: 19
        }
      },
      '52': {
        start: {
          line: 87,
          column: 4
        },
        end: {
          line: 87,
          column: 47
        }
      },
      '53': {
        start: {
          line: 88,
          column: 4
        },
        end: {
          line: 101,
          column: 6
        }
      },
      '54': {
        start: {
          line: 108,
          column: 4
        },
        end: {
          line: 134,
          column: 6
        }
      },
      '55': {
        start: {
          line: 113,
          column: 12
        },
        end: {
          line: 116,
          column: 14
        }
      },
      '56': {
        start: {
          line: 118,
          column: 12
        },
        end: {
          line: 118,
          column: 38
        }
      },
      '57': {
        start: {
          line: 123,
          column: 8
        },
        end: {
          line: 125,
          column: 9
        }
      },
      '58': {
        start: {
          line: 124,
          column: 10
        },
        end: {
          line: 124,
          column: 56
        }
      },
      '59': {
        start: {
          line: 126,
          column: 8
        },
        end: {
          line: 126,
          column: 74
        }
      },
      '60': {
        start: {
          line: 138,
          column: 2
        },
        end: {
          line: 202,
          column: 5
        }
      },
      '61': {
        start: {
          line: 139,
          column: 4
        },
        end: {
          line: 139,
          column: 33
        }
      },
      '62': {
        start: {
          line: 145,
          column: 4
        },
        end: {
          line: 201,
          column: 6
        }
      },
      '63': {
        start: {
          line: 205,
          column: 2
        },
        end: {
          line: 299,
          column: 5
        }
      },
      '64': {
        start: {
          line: 206,
          column: 19
        },
        end: {
          line: 206,
          column: 21
        }
      },
      '65': {
        start: {
          line: 207,
          column: 4
        },
        end: {
          line: 210,
          column: 5
        }
      },
      '66': {
        start: {
          line: 208,
          column: 6
        },
        end: {
          line: 208,
          column: 28
        }
      },
      '67': {
        start: {
          line: 209,
          column: 6
        },
        end: {
          line: 209,
          column: 32
        }
      },
      '68': {
        start: {
          line: 212,
          column: 22
        },
        end: {
          line: 212,
          column: 24
        }
      },
      '69': {
        start: {
          line: 214,
          column: 4
        },
        end: {
          line: 216,
          column: 7
        }
      },
      '70': {
        start: {
          line: 215,
          column: 6
        },
        end: {
          line: 215,
          column: 40
        }
      },
      '71': {
        start: {
          line: 218,
          column: 4
        },
        end: {
          line: 258,
          column: 5
        }
      },
      '72': {
        start: {
          line: 219,
          column: 20
        },
        end: {
          line: 221,
          column: 8
        }
      },
      '73': {
        start: {
          line: 220,
          column: 8
        },
        end: {
          line: 220,
          column: 81
        }
      },
      '74': {
        start: {
          line: 222,
          column: 6
        },
        end: {
          line: 228,
          column: 7
        }
      },
      '75': {
        start: {
          line: 223,
          column: 8
        },
        end: {
          line: 227,
          column: 43
        }
      },
      '76': {
        start: {
          line: 229,
          column: 6
        },
        end: {
          line: 257,
          column: 7
        }
      },
      '77': {
        start: {
          line: 230,
          column: 8
        },
        end: {
          line: 230,
          column: 73
        }
      },
      '78': {
        start: {
          line: 231,
          column: 8
        },
        end: {
          line: 231,
          column: 73
        }
      },
      '79': {
        start: {
          line: 232,
          column: 8
        },
        end: {
          line: 232,
          column: 80
        }
      },
      '80': {
        start: {
          line: 234,
          column: 8
        },
        end: {
          line: 245,
          column: 11
        }
      },
      '81': {
        start: {
          line: 246,
          column: 8
        },
        end: {
          line: 251,
          column: 11
        }
      },
      '82': {
        start: {
          line: 252,
          column: 8
        },
        end: {
          line: 256,
          column: 11
        }
      },
      '83': {
        start: {
          line: 260,
          column: 4
        },
        end: {
          line: 295,
          column: 6
        }
      },
      '84': {
        start: {
          line: 264,
          column: 21
        },
        end: {
          line: 264,
          column: 30
        }
      },
      '85': {
        start: {
          line: 265,
          column: 8
        },
        end: {
          line: 268,
          column: 9
        }
      },
      '86': {
        start: {
          line: 266,
          column: 10
        },
        end: {
          line: 266,
          column: 27
        }
      },
      '87': {
        start: {
          line: 267,
          column: 10
        },
        end: {
          line: 267,
          column: 17
        }
      },
      '88': {
        start: {
          line: 270,
          column: 8
        },
        end: {
          line: 272,
          column: 9
        }
      },
      '89': {
        start: {
          line: 271,
          column: 10
        },
        end: {
          line: 271,
          column: 27
        }
      },
      '90': {
        start: {
          line: 274,
          column: 8
        },
        end: {
          line: 276,
          column: 9
        }
      },
      '91': {
        start: {
          line: 275,
          column: 10
        },
        end: {
          line: 275,
          column: 27
        }
      },
      '92': {
        start: {
          line: 278,
          column: 8
        },
        end: {
          line: 280,
          column: 9
        }
      },
      '93': {
        start: {
          line: 279,
          column: 10
        },
        end: {
          line: 279,
          column: 27
        }
      },
      '94': {
        start: {
          line: 302,
          column: 2
        },
        end: {
          line: 555,
          column: 5
        }
      },
      '95': {
        start: {
          line: 303,
          column: 4
        },
        end: {
          line: 452,
          column: 6
        }
      },
      '96': {
        start: {
          line: 305,
          column: 21
        },
        end: {
          line: 305,
          column: 30
        }
      },
      '97': {
        start: {
          line: 306,
          column: 8
        },
        end: {
          line: 308,
          column: 9
        }
      },
      '98': {
        start: {
          line: 307,
          column: 10
        },
        end: {
          line: 307,
          column: 35
        }
      },
      '99': {
        start: {
          line: 311,
          column: 8
        },
        end: {
          line: 313,
          column: 9
        }
      },
      '100': {
        start: {
          line: 312,
          column: 10
        },
        end: {
          line: 312,
          column: 55
        }
      },
      '101': {
        start: {
          line: 314,
          column: 8
        },
        end: {
          line: 314,
          column: 52
        }
      },
      '102': {
        start: {
          line: 317,
          column: 8
        },
        end: {
          line: 319,
          column: 9
        }
      },
      '103': {
        start: {
          line: 318,
          column: 10
        },
        end: {
          line: 318,
          column: 17
        }
      },
      '104': {
        start: {
          line: 320,
          column: 8
        },
        end: {
          line: 320,
          column: 51
        }
      },
      '105': {
        start: {
          line: 322,
          column: 22
        },
        end: {
          line: 322,
          column: 31
        }
      },
      '106': {
        start: {
          line: 324,
          column: 8
        },
        end: {
          line: 327,
          column: 11
        }
      },
      '107': {
        start: {
          line: 328,
          column: 8
        },
        end: {
          line: 328,
          column: 111
        }
      },
      '108': {
        start: {
          line: 329,
          column: 8
        },
        end: {
          line: 329,
          column: 113
        }
      },
      '109': {
        start: {
          line: 331,
          column: 8
        },
        end: {
          line: 331,
          column: 71
        }
      },
      '110': {
        start: {
          line: 332,
          column: 8
        },
        end: {
          line: 335,
          column: 9
        }
      },
      '111': {
        start: {
          line: 333,
          column: 10
        },
        end: {
          line: 333,
          column: 52
        }
      },
      '112': {
        start: {
          line: 334,
          column: 10
        },
        end: {
          line: 334,
          column: 17
        }
      },
      '113': {
        start: {
          line: 336,
          column: 8
        },
        end: {
          line: 336,
          column: 53
        }
      },
      '114': {
        start: {
          line: 337,
          column: 22
        },
        end: {
          line: 337,
          column: 29
        }
      },
      '115': {
        start: {
          line: 338,
          column: 20
        },
        end: {
          line: 338,
          column: 27
        }
      },
      '116': {
        start: {
          line: 339,
          column: 22
        },
        end: {
          line: 339,
          column: 45
        }
      },
      '117': {
        start: {
          line: 340,
          column: 23
        },
        end: {
          line: 405,
          column: 9
        }
      },
      '118': {
        start: {
          line: 407,
          column: 8
        },
        end: {
          line: 410,
          column: 11
        }
      },
      '119': {
        start: {
          line: 411,
          column: 8
        },
        end: {
          line: 414,
          column: 11
        }
      },
      '120': {
        start: {
          line: 415,
          column: 8
        },
        end: {
          line: 418,
          column: 11
        }
      },
      '121': {
        start: {
          line: 419,
          column: 8
        },
        end: {
          line: 432,
          column: 9
        }
      },
      '122': {
        start: {
          line: 420,
          column: 10
        },
        end: {
          line: 423,
          column: 13
        }
      },
      '123': {
        start: {
          line: 424,
          column: 10
        },
        end: {
          line: 427,
          column: 13
        }
      },
      '124': {
        start: {
          line: 428,
          column: 10
        },
        end: {
          line: 431,
          column: 13
        }
      },
      '125': {
        start: {
          line: 433,
          column: 8
        },
        end: {
          line: 436,
          column: 11
        }
      },
      '126': {
        start: {
          line: 437,
          column: 8
        },
        end: {
          line: 440,
          column: 11
        }
      },
      '127': {
        start: {
          line: 441,
          column: 8
        },
        end: {
          line: 444,
          column: 11
        }
      },
      '128': {
        start: {
          line: 446,
          column: 8
        },
        end: {
          line: 446,
          column: 52
        }
      },
      '129': {
        start: {
          line: 449,
          column: 8
        },
        end: {
          line: 449,
          column: 50
        }
      },
      '130': {
        start: {
          line: 450,
          column: 8
        },
        end: {
          line: 450,
          column: 49
        }
      },
      '131': {
        start: {
          line: 453,
          column: 4
        },
        end: {
          line: 453,
          column: 63
        }
      },
      '132': {
        start: {
          line: 456,
          column: 4
        },
        end: {
          line: 456,
          column: 18
        }
      },
      '133': {
        start: {
          line: 457,
          column: 18
        },
        end: {
          line: 457,
          column: 24
        }
      },
      '134': {
        start: {
          line: 458,
          column: 4
        },
        end: {
          line: 458,
          column: 43
        }
      },
      '135': {
        start: {
          line: 459,
          column: 24
        },
        end: {
          line: 459,
          column: 26
        }
      },
      '136': {
        start: {
          line: 460,
          column: 20
        },
        end: {
          line: 467,
          column: 5
        }
      },
      '137': {
        start: {
          line: 464,
          column: 8
        },
        end: {
          line: 464,
          column: 51
        }
      },
      '138': {
        start: {
          line: 468,
          column: 4
        },
        end: {
          line: 473,
          column: 5
        }
      },
      '139': {
        start: {
          line: 469,
          column: 6
        },
        end: {
          line: 472,
          column: 10
        }
      },
      '140': {
        start: {
          line: 474,
          column: 4
        },
        end: {
          line: 474,
          column: 168
        }
      },
      '141': {
        start: {
          line: 476,
          column: 4
        },
        end: {
          line: 476,
          column: 27
        }
      },
      '142': {
        start: {
          line: 477,
          column: 4
        },
        end: {
          line: 477,
          column: 61
        }
      },
      '143': {
        start: {
          line: 480,
          column: 4
        },
        end: {
          line: 516,
          column: 5
        }
      },
      '144': {
        start: {
          line: 481,
          column: 6
        },
        end: {
          line: 483,
          column: 64
        }
      },
      '145': {
        start: {
          line: 484,
          column: 6
        },
        end: {
          line: 491,
          column: 7
        }
      },
      '146': {
        start: {
          line: 485,
          column: 8
        },
        end: {
          line: 485,
          column: 62
        }
      },
      '147': {
        start: {
          line: 486,
          column: 8
        },
        end: {
          line: 486,
          column: 62
        }
      },
      '148': {
        start: {
          line: 487,
          column: 8
        },
        end: {
          line: 490,
          column: 9
        }
      },
      '149': {
        start: {
          line: 488,
          column: 10
        },
        end: {
          line: 488,
          column: 70
        }
      },
      '150': {
        start: {
          line: 489,
          column: 10
        },
        end: {
          line: 489,
          column: 82
        }
      },
      '151': {
        start: {
          line: 492,
          column: 19
        },
        end: {
          line: 492,
          column: 35
        }
      },
      '152': {
        start: {
          line: 493,
          column: 6
        },
        end: {
          line: 493,
          column: 25
        }
      },
      '153': {
        start: {
          line: 494,
          column: 6
        },
        end: {
          line: 494,
          column: 29
        }
      },
      '154': {
        start: {
          line: 495,
          column: 6
        },
        end: {
          line: 515,
          column: 7
        }
      },
      '155': {
        start: {
          line: 496,
          column: 8
        },
        end: {
          line: 496,
          column: 38
        }
      },
      '156': {
        start: {
          line: 497,
          column: 8
        },
        end: {
          line: 497,
          column: 23
        }
      },
      '157': {
        start: {
          line: 498,
          column: 8
        },
        end: {
          line: 498,
          column: 63
        }
      },
      '158': {
        start: {
          line: 499,
          column: 8
        },
        end: {
          line: 500,
          column: 124
        }
      },
      '159': {
        start: {
          line: 501,
          column: 8
        },
        end: {
          line: 501,
          column: 23
        }
      },
      '160': {
        start: {
          line: 502,
          column: 8
        },
        end: {
          line: 502,
          column: 23
        }
      },
      '161': {
        start: {
          line: 503,
          column: 8
        },
        end: {
          line: 503,
          column: 25
        }
      },
      '162': {
        start: {
          line: 504,
          column: 8
        },
        end: {
          line: 504,
          column: 40
        }
      },
      '163': {
        start: {
          line: 505,
          column: 8
        },
        end: {
          line: 505,
          column: 23
        }
      },
      '164': {
        start: {
          line: 506,
          column: 8
        },
        end: {
          line: 506,
          column: 23
        }
      },
      '165': {
        start: {
          line: 507,
          column: 8
        },
        end: {
          line: 507,
          column: 27
        }
      },
      '166': {
        start: {
          line: 508,
          column: 8
        },
        end: {
          line: 508,
          column: 23
        }
      },
      '167': {
        start: {
          line: 510,
          column: 8
        },
        end: {
          line: 513,
          column: 9
        }
      },
      '168': {
        start: {
          line: 511,
          column: 10
        },
        end: {
          line: 511,
          column: 72
        }
      },
      '169': {
        start: {
          line: 512,
          column: 10
        },
        end: {
          line: 512,
          column: 84
        }
      },
      '170': {
        start: {
          line: 514,
          column: 8
        },
        end: {
          line: 514,
          column: 30
        }
      },
      '171': {
        start: {
          line: 518,
          column: 4
        },
        end: {
          line: 536,
          column: 7
        }
      },
      '172': {
        start: {
          line: 519,
          column: 6
        },
        end: {
          line: 521,
          column: 7
        }
      },
      '173': {
        start: {
          line: 520,
          column: 8
        },
        end: {
          line: 520,
          column: 17
        }
      },
      '174': {
        start: {
          line: 522,
          column: 6
        },
        end: {
          line: 524,
          column: 7
        }
      },
      '175': {
        start: {
          line: 523,
          column: 8
        },
        end: {
          line: 523,
          column: 18
        }
      },
      '176': {
        start: {
          line: 526,
          column: 6
        },
        end: {
          line: 528,
          column: 7
        }
      },
      '177': {
        start: {
          line: 527,
          column: 8
        },
        end: {
          line: 527,
          column: 17
        }
      },
      '178': {
        start: {
          line: 529,
          column: 6
        },
        end: {
          line: 531,
          column: 7
        }
      },
      '179': {
        start: {
          line: 530,
          column: 8
        },
        end: {
          line: 530,
          column: 18
        }
      },
      '180': {
        start: {
          line: 532,
          column: 6
        },
        end: {
          line: 534,
          column: 7
        }
      },
      '181': {
        start: {
          line: 533,
          column: 8
        },
        end: {
          line: 533,
          column: 18
        }
      },
      '182': {
        start: {
          line: 535,
          column: 6
        },
        end: {
          line: 535,
          column: 15
        }
      },
      '183': {
        start: {
          line: 540,
          column: 24
        },
        end: {
          line: 540,
          column: 26
        }
      },
      '184': {
        start: {
          line: 541,
          column: 4
        },
        end: {
          line: 551,
          column: 5
        }
      },
      '185': {
        start: {
          line: 542,
          column: 17
        },
        end: {
          line: 542,
          column: 34
        }
      },
      '186': {
        start: {
          line: 543,
          column: 6
        },
        end: {
          line: 543,
          column: 64
        }
      },
      '187': {
        start: {
          line: 544,
          column: 6
        },
        end: {
          line: 544,
          column: 175
        }
      },
      '188': {
        start: {
          line: 545,
          column: 6
        },
        end: {
          line: 545,
          column: 27
        }
      },
      '189': {
        start: {
          line: 546,
          column: 6
        },
        end: {
          line: 550,
          column: 7
        }
      },
      '190': {
        start: {
          line: 547,
          column: 8
        },
        end: {
          line: 547,
          column: 38
        }
      },
      '191': {
        start: {
          line: 549,
          column: 8
        },
        end: {
          line: 549,
          column: 31
        }
      },
      '192': {
        start: {
          line: 553,
          column: 4
        },
        end: {
          line: 553,
          column: 54
        }
      },
      '193': {
        start: {
          line: 558,
          column: 2
        },
        end: {
          line: 716,
          column: 5
        }
      },
      '194': {
        start: {
          line: 559,
          column: 4
        },
        end: {
          line: 659,
          column: 6
        }
      },
      '195': {
        start: {
          line: 562,
          column: 8
        },
        end: {
          line: 564,
          column: 9
        }
      },
      '196': {
        start: {
          line: 563,
          column: 10
        },
        end: {
          line: 563,
          column: 61
        }
      },
      '197': {
        start: {
          line: 565,
          column: 8
        },
        end: {
          line: 565,
          column: 58
        }
      },
      '198': {
        start: {
          line: 568,
          column: 8
        },
        end: {
          line: 568,
          column: 57
        }
      },
      '199': {
        start: {
          line: 570,
          column: 22
        },
        end: {
          line: 570,
          column: 31
        }
      },
      '200': {
        start: {
          line: 572,
          column: 8
        },
        end: {
          line: 575,
          column: 11
        }
      },
      '201': {
        start: {
          line: 576,
          column: 8
        },
        end: {
          line: 576,
          column: 123
        }
      },
      '202': {
        start: {
          line: 577,
          column: 8
        },
        end: {
          line: 577,
          column: 125
        }
      },
      '203': {
        start: {
          line: 579,
          column: 8
        },
        end: {
          line: 579,
          column: 77
        }
      },
      '204': {
        start: {
          line: 580,
          column: 8
        },
        end: {
          line: 583,
          column: 9
        }
      },
      '205': {
        start: {
          line: 581,
          column: 10
        },
        end: {
          line: 581,
          column: 58
        }
      },
      '206': {
        start: {
          line: 582,
          column: 10
        },
        end: {
          line: 582,
          column: 17
        }
      },
      '207': {
        start: {
          line: 584,
          column: 8
        },
        end: {
          line: 584,
          column: 59
        }
      },
      '208': {
        start: {
          line: 585,
          column: 22
        },
        end: {
          line: 585,
          column: 45
        }
      },
      '209': {
        start: {
          line: 586,
          column: 8
        },
        end: {
          line: 586,
          column: 56
        }
      },
      '210': {
        start: {
          line: 587,
          column: 8
        },
        end: {
          line: 653,
          column: 11
        }
      },
      '211': {
        start: {
          line: 588,
          column: 25
        },
        end: {
          line: 636,
          column: 11
        }
      },
      '212': {
        start: {
          line: 637,
          column: 30
        },
        end: {
          line: 637,
          column: 99
        }
      },
      '213': {
        start: {
          line: 638,
          column: 28
        },
        end: {
          line: 638,
          column: 97
        }
      },
      '214': {
        start: {
          line: 639,
          column: 10
        },
        end: {
          line: 651,
          column: 11
        }
      },
      '215': {
        start: {
          line: 640,
          column: 12
        },
        end: {
          line: 650,
          column: 13
        }
      },
      '216': {
        start: {
          line: 641,
          column: 34
        },
        end: {
          line: 641,
          column: 81
        }
      },
      '217': {
        start: {
          line: 642,
          column: 32
        },
        end: {
          line: 642,
          column: 77
        }
      },
      '218': {
        start: {
          line: 643,
          column: 14
        },
        end: {
          line: 645,
          column: 15
        }
      },
      '219': {
        start: {
          line: 644,
          column: 16
        },
        end: {
          line: 644,
          column: 25
        }
      },
      '220': {
        start: {
          line: 646,
          column: 14
        },
        end: {
          line: 649,
          column: 17
        }
      },
      '221': {
        start: {
          line: 652,
          column: 10
        },
        end: {
          line: 652,
          column: 60
        }
      },
      '222': {
        start: {
          line: 656,
          column: 8
        },
        end: {
          line: 656,
          column: 56
        }
      },
      '223': {
        start: {
          line: 657,
          column: 8
        },
        end: {
          line: 657,
          column: 55
        }
      },
      '224': {
        start: {
          line: 660,
          column: 4
        },
        end: {
          line: 660,
          column: 78
        }
      },
      '225': {
        start: {
          line: 663,
          column: 4
        },
        end: {
          line: 663,
          column: 18
        }
      },
      '226': {
        start: {
          line: 664,
          column: 18
        },
        end: {
          line: 666,
          column: 6
        }
      },
      '227': {
        start: {
          line: 665,
          column: 6
        },
        end: {
          line: 665,
          column: 134
        }
      },
      '228': {
        start: {
          line: 667,
          column: 4
        },
        end: {
          line: 667,
          column: 49
        }
      },
      '229': {
        start: {
          line: 669,
          column: 20
        },
        end: {
          line: 675,
          column: 5
        }
      },
      '230': {
        start: {
          line: 673,
          column: 8
        },
        end: {
          line: 673,
          column: 57
        }
      },
      '231': {
        start: {
          line: 676,
          column: 4
        },
        end: {
          line: 678,
          column: 5
        }
      },
      '232': {
        start: {
          line: 677,
          column: 6
        },
        end: {
          line: 677,
          column: 138
        }
      },
      '233': {
        start: {
          line: 680,
          column: 4
        },
        end: {
          line: 680,
          column: 67
        }
      },
      '234': {
        start: {
          line: 683,
          column: 24
        },
        end: {
          line: 683,
          column: 26
        }
      },
      '235': {
        start: {
          line: 684,
          column: 4
        },
        end: {
          line: 694,
          column: 5
        }
      },
      '236': {
        start: {
          line: 685,
          column: 6
        },
        end: {
          line: 685,
          column: 49
        }
      },
      '237': {
        start: {
          line: 686,
          column: 6
        },
        end: {
          line: 690,
          column: 7
        }
      },
      '238': {
        start: {
          line: 687,
          column: 8
        },
        end: {
          line: 689,
          column: 9
        }
      },
      '239': {
        start: {
          line: 688,
          column: 10
        },
        end: {
          line: 688,
          column: 70
        }
      },
      '240': {
        start: {
          line: 691,
          column: 19
        },
        end: {
          line: 691,
          column: 35
        }
      },
      '241': {
        start: {
          line: 692,
          column: 6
        },
        end: {
          line: 692,
          column: 25
        }
      },
      '242': {
        start: {
          line: 693,
          column: 6
        },
        end: {
          line: 693,
          column: 29
        }
      },
      '243': {
        start: {
          line: 696,
          column: 4
        },
        end: {
          line: 714,
          column: 7
        }
      },
      '244': {
        start: {
          line: 697,
          column: 6
        },
        end: {
          line: 699,
          column: 7
        }
      },
      '245': {
        start: {
          line: 698,
          column: 8
        },
        end: {
          line: 698,
          column: 17
        }
      },
      '246': {
        start: {
          line: 700,
          column: 6
        },
        end: {
          line: 702,
          column: 7
        }
      },
      '247': {
        start: {
          line: 701,
          column: 8
        },
        end: {
          line: 701,
          column: 18
        }
      },
      '248': {
        start: {
          line: 704,
          column: 6
        },
        end: {
          line: 706,
          column: 7
        }
      },
      '249': {
        start: {
          line: 705,
          column: 8
        },
        end: {
          line: 705,
          column: 17
        }
      },
      '250': {
        start: {
          line: 707,
          column: 6
        },
        end: {
          line: 709,
          column: 7
        }
      },
      '251': {
        start: {
          line: 708,
          column: 8
        },
        end: {
          line: 708,
          column: 18
        }
      },
      '252': {
        start: {
          line: 710,
          column: 6
        },
        end: {
          line: 712,
          column: 7
        }
      },
      '253': {
        start: {
          line: 711,
          column: 8
        },
        end: {
          line: 711,
          column: 18
        }
      },
      '254': {
        start: {
          line: 713,
          column: 6
        },
        end: {
          line: 713,
          column: 15
        }
      },
      '255': {
        start: {
          line: 715,
          column: 4
        },
        end: {
          line: 715,
          column: 60
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 1,
            column: 57
          },
          end: {
            line: 1,
            column: 58
          }
        },
        loc: {
          start: {
            line: 1,
            column: 190
          },
          end: {
            line: 717,
            column: 1
          }
        },
        line: 1
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 18,
            column: 33
          },
          end: {
            line: 18,
            column: 34
          }
        },
        loc: {
          start: {
            line: 18,
            column: 47
          },
          end: {
            line: 21,
            column: 3
          }
        },
        line: 18
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 35,
            column: 21
          },
          end: {
            line: 35,
            column: 22
          }
        },
        loc: {
          start: {
            line: 35,
            column: 35
          },
          end: {
            line: 37,
            column: 3
          }
        },
        line: 35
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 38,
            column: 22
          },
          end: {
            line: 38,
            column: 23
          }
        },
        loc: {
          start: {
            line: 38,
            column: 36
          },
          end: {
            line: 52,
            column: 3
          }
        },
        line: 38
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 54,
            column: 68
          },
          end: {
            line: 54,
            column: 69
          }
        },
        loc: {
          start: {
            line: 54,
            column: 76
          },
          end: {
            line: 76,
            column: 3
          }
        },
        line: 54
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 79,
            column: 69
          },
          end: {
            line: 79,
            column: 70
          }
        },
        loc: {
          start: {
            line: 79,
            column: 77
          },
          end: {
            line: 135,
            column: 3
          }
        },
        line: 79
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 80,
            column: 20
          },
          end: {
            line: 80,
            column: 21
          }
        },
        loc: {
          start: {
            line: 80,
            column: 29
          },
          end: {
            line: 85,
            column: 5
          }
        },
        line: 80
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 112,
            column: 45
          },
          end: {
            line: 112,
            column: 46
          }
        },
        loc: {
          start: {
            line: 112,
            column: 54
          },
          end: {
            line: 117,
            column: 11
          }
        },
        line: 112
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 117,
            column: 21
          },
          end: {
            line: 117,
            column: 22
          }
        },
        loc: {
          start: {
            line: 117,
            column: 29
          },
          end: {
            line: 119,
            column: 11
          }
        },
        line: 117
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 138,
            column: 75
          },
          end: {
            line: 138,
            column: 76
          }
        },
        loc: {
          start: {
            line: 138,
            column: 83
          },
          end: {
            line: 202,
            column: 3
          }
        },
        line: 138
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 205,
            column: 104
          },
          end: {
            line: 205,
            column: 105
          }
        },
        loc: {
          start: {
            line: 205,
            column: 112
          },
          end: {
            line: 299,
            column: 3
          }
        },
        line: 205
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 214,
            column: 16
          },
          end: {
            line: 214,
            column: 17
          }
        },
        loc: {
          start: {
            line: 214,
            column: 26
          },
          end: {
            line: 216,
            column: 5
          }
        },
        line: 214
      },
      '12': {
        name: '(anonymous_12)',
        decl: {
          start: {
            line: 219,
            column: 34
          },
          end: {
            line: 219,
            column: 35
          }
        },
        loc: {
          start: {
            line: 219,
            column: 47
          },
          end: {
            line: 221,
            column: 7
          }
        },
        line: 219
      },
      '13': {
        name: '(anonymous_13)',
        decl: {
          start: {
            line: 302,
            column: 105
          },
          end: {
            line: 302,
            column: 106
          }
        },
        loc: {
          start: {
            line: 302,
            column: 113
          },
          end: {
            line: 555,
            column: 3
          }
        },
        line: 302
      },
      '14': {
        name: '(anonymous_14)',
        decl: {
          start: {
            line: 518,
            column: 21
          },
          end: {
            line: 518,
            column: 22
          }
        },
        loc: {
          start: {
            line: 518,
            column: 31
          },
          end: {
            line: 536,
            column: 5
          }
        },
        line: 518
      },
      '15': {
        name: '(anonymous_15)',
        decl: {
          start: {
            line: 546,
            column: 44
          },
          end: {
            line: 546,
            column: 45
          }
        },
        loc: {
          start: {
            line: 546,
            column: 53
          },
          end: {
            line: 548,
            column: 7
          }
        },
        line: 546
      },
      '16': {
        name: '(anonymous_16)',
        decl: {
          start: {
            line: 558,
            column: 112
          },
          end: {
            line: 558,
            column: 113
          }
        },
        loc: {
          start: {
            line: 558,
            column: 120
          },
          end: {
            line: 716,
            column: 3
          }
        },
        line: 558
      },
      '17': {
        name: '(anonymous_17)',
        decl: {
          start: {
            line: 587,
            column: 143
          },
          end: {
            line: 587,
            column: 144
          }
        },
        loc: {
          start: {
            line: 587,
            column: 152
          },
          end: {
            line: 653,
            column: 9
          }
        },
        line: 587
      },
      '18': {
        name: '(anonymous_18)',
        decl: {
          start: {
            line: 664,
            column: 32
          },
          end: {
            line: 664,
            column: 33
          }
        },
        loc: {
          start: {
            line: 664,
            column: 40
          },
          end: {
            line: 666,
            column: 5
          }
        },
        line: 664
      },
      '19': {
        name: '(anonymous_19)',
        decl: {
          start: {
            line: 696,
            column: 21
          },
          end: {
            line: 696,
            column: 22
          }
        },
        loc: {
          start: {
            line: 696,
            column: 31
          },
          end: {
            line: 714,
            column: 5
          }
        },
        line: 696
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 20,
            column: 11
          },
          end: {
            line: 20,
            column: 36
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 20,
            column: 20
          },
          end: {
            line: 20,
            column: 31
          }
        }, {
          start: {
            line: 20,
            column: 34
          },
          end: {
            line: 20,
            column: 36
          }
        }],
        line: 20
      },
      '1': {
        loc: {
          start: {
            line: 40,
            column: 4
          },
          end: {
            line: 43,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 40,
            column: 4
          },
          end: {
            line: 43,
            column: 5
          }
        }, {
          start: {
            line: 40,
            column: 4
          },
          end: {
            line: 43,
            column: 5
          }
        }],
        line: 40
      },
      '2': {
        loc: {
          start: {
            line: 41,
            column: 14
          },
          end: {
            line: 41,
            column: 32
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 41,
            column: 14
          },
          end: {
            line: 41,
            column: 26
          }
        }, {
          start: {
            line: 41,
            column: 30
          },
          end: {
            line: 41,
            column: 32
          }
        }],
        line: 41
      },
      '3': {
        loc: {
          start: {
            line: 44,
            column: 12
          },
          end: {
            line: 44,
            column: 30
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 44,
            column: 12
          },
          end: {
            line: 44,
            column: 24
          }
        }, {
          start: {
            line: 44,
            column: 28
          },
          end: {
            line: 44,
            column: 30
          }
        }],
        line: 44
      },
      '4': {
        loc: {
          start: {
            line: 45,
            column: 4
          },
          end: {
            line: 47,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 45,
            column: 4
          },
          end: {
            line: 47,
            column: 5
          }
        }, {
          start: {
            line: 45,
            column: 4
          },
          end: {
            line: 47,
            column: 5
          }
        }],
        line: 45
      },
      '5': {
        loc: {
          start: {
            line: 46,
            column: 14
          },
          end: {
            line: 46,
            column: 32
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 46,
            column: 14
          },
          end: {
            line: 46,
            column: 26
          }
        }, {
          start: {
            line: 46,
            column: 30
          },
          end: {
            line: 46,
            column: 32
          }
        }],
        line: 46
      },
      '6': {
        loc: {
          start: {
            line: 49,
            column: 20
          },
          end: {
            line: 49,
            column: 47
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 49,
            column: 20
          },
          end: {
            line: 49,
            column: 41
          }
        }, {
          start: {
            line: 49,
            column: 45
          },
          end: {
            line: 49,
            column: 47
          }
        }],
        line: 49
      },
      '7': {
        loc: {
          start: {
            line: 51,
            column: 12
          },
          end: {
            line: 51,
            column: 27
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 51,
            column: 12
          },
          end: {
            line: 51,
            column: 21
          }
        }, {
          start: {
            line: 51,
            column: 25
          },
          end: {
            line: 51,
            column: 27
          }
        }],
        line: 51
      },
      '8': {
        loc: {
          start: {
            line: 55,
            column: 4
          },
          end: {
            line: 58,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 55,
            column: 4
          },
          end: {
            line: 58,
            column: 5
          }
        }, {
          start: {
            line: 55,
            column: 4
          },
          end: {
            line: 58,
            column: 5
          }
        }],
        line: 55
      },
      '9': {
        loc: {
          start: {
            line: 60,
            column: 6
          },
          end: {
            line: 62,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 60,
            column: 6
          },
          end: {
            line: 62,
            column: 7
          }
        }, {
          start: {
            line: 60,
            column: 6
          },
          end: {
            line: 62,
            column: 7
          }
        }],
        line: 60
      },
      '10': {
        loc: {
          start: {
            line: 67,
            column: 41
          },
          end: {
            line: 67,
            column: 73
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 67,
            column: 41
          },
          end: {
            line: 67,
            column: 60
          }
        }, {
          start: {
            line: 67,
            column: 64
          },
          end: {
            line: 67,
            column: 73
          }
        }],
        line: 67
      },
      '11': {
        loc: {
          start: {
            line: 114,
            column: 21
          },
          end: {
            line: 114,
            column: 73
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 114,
            column: 39
          },
          end: {
            line: 114,
            column: 66
          }
        }, {
          start: {
            line: 114,
            column: 69
          },
          end: {
            line: 114,
            column: 73
          }
        }],
        line: 114
      },
      '12': {
        loc: {
          start: {
            line: 123,
            column: 8
          },
          end: {
            line: 125,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 123,
            column: 8
          },
          end: {
            line: 125,
            column: 9
          }
        }, {
          start: {
            line: 123,
            column: 8
          },
          end: {
            line: 125,
            column: 9
          }
        }],
        line: 123
      },
      '13': {
        loc: {
          start: {
            line: 215,
            column: 13
          },
          end: {
            line: 215,
            column: 39
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 215,
            column: 33
          },
          end: {
            line: 215,
            column: 34
          }
        }, {
          start: {
            line: 215,
            column: 37
          },
          end: {
            line: 215,
            column: 39
          }
        }],
        line: 215
      },
      '14': {
        loc: {
          start: {
            line: 220,
            column: 15
          },
          end: {
            line: 220,
            column: 80
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 220,
            column: 15
          },
          end: {
            line: 220,
            column: 38
          }
        }, {
          start: {
            line: 220,
            column: 43
          },
          end: {
            line: 220,
            column: 59
          }
        }, {
          start: {
            line: 220,
            column: 63
          },
          end: {
            line: 220,
            column: 79
          }
        }],
        line: 220
      },
      '15': {
        loc: {
          start: {
            line: 222,
            column: 6
          },
          end: {
            line: 228,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 222,
            column: 6
          },
          end: {
            line: 228,
            column: 7
          }
        }, {
          start: {
            line: 222,
            column: 6
          },
          end: {
            line: 228,
            column: 7
          }
        }],
        line: 222
      },
      '16': {
        loc: {
          start: {
            line: 248,
            column: 15
          },
          end: {
            line: 248,
            column: 56
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 248,
            column: 26
          },
          end: {
            line: 248,
            column: 51
          }
        }, {
          start: {
            line: 248,
            column: 54
          },
          end: {
            line: 248,
            column: 56
          }
        }],
        line: 248
      },
      '17': {
        loc: {
          start: {
            line: 249,
            column: 15
          },
          end: {
            line: 249,
            column: 60
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 249,
            column: 28
          },
          end: {
            line: 249,
            column: 55
          }
        }, {
          start: {
            line: 249,
            column: 58
          },
          end: {
            line: 249,
            column: 60
          }
        }],
        line: 249
      },
      '18': {
        loc: {
          start: {
            line: 250,
            column: 18
          },
          end: {
            line: 250,
            column: 55
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 250,
            column: 27
          },
          end: {
            line: 250,
            column: 50
          }
        }, {
          start: {
            line: 250,
            column: 53
          },
          end: {
            line: 250,
            column: 55
          }
        }],
        line: 250
      },
      '19': {
        loc: {
          start: {
            line: 265,
            column: 8
          },
          end: {
            line: 268,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 265,
            column: 8
          },
          end: {
            line: 268,
            column: 9
          }
        }, {
          start: {
            line: 265,
            column: 8
          },
          end: {
            line: 268,
            column: 9
          }
        }],
        line: 265
      },
      '20': {
        loc: {
          start: {
            line: 270,
            column: 8
          },
          end: {
            line: 272,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 270,
            column: 8
          },
          end: {
            line: 272,
            column: 9
          }
        }, {
          start: {
            line: 270,
            column: 8
          },
          end: {
            line: 272,
            column: 9
          }
        }],
        line: 270
      },
      '21': {
        loc: {
          start: {
            line: 270,
            column: 12
          },
          end: {
            line: 270,
            column: 49
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 270,
            column: 12
          },
          end: {
            line: 270,
            column: 38
          }
        }, {
          start: {
            line: 270,
            column: 42
          },
          end: {
            line: 270,
            column: 49
          }
        }],
        line: 270
      },
      '22': {
        loc: {
          start: {
            line: 274,
            column: 8
          },
          end: {
            line: 276,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 274,
            column: 8
          },
          end: {
            line: 276,
            column: 9
          }
        }, {
          start: {
            line: 274,
            column: 8
          },
          end: {
            line: 276,
            column: 9
          }
        }],
        line: 274
      },
      '23': {
        loc: {
          start: {
            line: 274,
            column: 12
          },
          end: {
            line: 274,
            column: 55
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 274,
            column: 12
          },
          end: {
            line: 274,
            column: 39
          }
        }, {
          start: {
            line: 274,
            column: 43
          },
          end: {
            line: 274,
            column: 55
          }
        }],
        line: 274
      },
      '24': {
        loc: {
          start: {
            line: 278,
            column: 8
          },
          end: {
            line: 280,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 278,
            column: 8
          },
          end: {
            line: 280,
            column: 9
          }
        }, {
          start: {
            line: 278,
            column: 8
          },
          end: {
            line: 280,
            column: 9
          }
        }],
        line: 278
      },
      '25': {
        loc: {
          start: {
            line: 278,
            column: 12
          },
          end: {
            line: 278,
            column: 49
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 278,
            column: 12
          },
          end: {
            line: 278,
            column: 38
          }
        }, {
          start: {
            line: 278,
            column: 42
          },
          end: {
            line: 278,
            column: 49
          }
        }],
        line: 278
      },
      '26': {
        loc: {
          start: {
            line: 306,
            column: 8
          },
          end: {
            line: 308,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 306,
            column: 8
          },
          end: {
            line: 308,
            column: 9
          }
        }, {
          start: {
            line: 306,
            column: 8
          },
          end: {
            line: 308,
            column: 9
          }
        }],
        line: 306
      },
      '27': {
        loc: {
          start: {
            line: 306,
            column: 12
          },
          end: {
            line: 306,
            column: 51
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 306,
            column: 12
          },
          end: {
            line: 306,
            column: 21
          }
        }, {
          start: {
            line: 306,
            column: 25
          },
          end: {
            line: 306,
            column: 51
          }
        }],
        line: 306
      },
      '28': {
        loc: {
          start: {
            line: 311,
            column: 8
          },
          end: {
            line: 313,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 311,
            column: 8
          },
          end: {
            line: 313,
            column: 9
          }
        }, {
          start: {
            line: 311,
            column: 8
          },
          end: {
            line: 313,
            column: 9
          }
        }],
        line: 311
      },
      '29': {
        loc: {
          start: {
            line: 317,
            column: 8
          },
          end: {
            line: 319,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 317,
            column: 8
          },
          end: {
            line: 319,
            column: 9
          }
        }, {
          start: {
            line: 317,
            column: 8
          },
          end: {
            line: 319,
            column: 9
          }
        }],
        line: 317
      },
      '30': {
        loc: {
          start: {
            line: 332,
            column: 8
          },
          end: {
            line: 335,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 332,
            column: 8
          },
          end: {
            line: 335,
            column: 9
          }
        }, {
          start: {
            line: 332,
            column: 8
          },
          end: {
            line: 335,
            column: 9
          }
        }],
        line: 332
      },
      '31': {
        loc: {
          start: {
            line: 483,
            column: 34
          },
          end: {
            line: 483,
            column: 49
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 483,
            column: 34
          },
          end: {
            line: 483,
            column: 40
          }
        }, {
          start: {
            line: 483,
            column: 44
          },
          end: {
            line: 483,
            column: 49
          }
        }],
        line: 483
      },
      '32': {
        loc: {
          start: {
            line: 484,
            column: 6
          },
          end: {
            line: 491,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 484,
            column: 6
          },
          end: {
            line: 491,
            column: 7
          }
        }, {
          start: {
            line: 484,
            column: 6
          },
          end: {
            line: 491,
            column: 7
          }
        }],
        line: 484
      },
      '33': {
        loc: {
          start: {
            line: 484,
            column: 10
          },
          end: {
            line: 484,
            column: 32
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 484,
            column: 10
          },
          end: {
            line: 484,
            column: 19
          }
        }, {
          start: {
            line: 484,
            column: 23
          },
          end: {
            line: 484,
            column: 32
          }
        }],
        line: 484
      },
      '34': {
        loc: {
          start: {
            line: 496,
            column: 17
          },
          end: {
            line: 496,
            column: 37
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 496,
            column: 27
          },
          end: {
            line: 496,
            column: 29
          }
        }, {
          start: {
            line: 496,
            column: 32
          },
          end: {
            line: 496,
            column: 37
          }
        }],
        line: 496
      },
      '35': {
        loc: {
          start: {
            line: 498,
            column: 17
          },
          end: {
            line: 498,
            column: 62
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 498,
            column: 42
          },
          end: {
            line: 498,
            column: 48
          }
        }, {
          start: {
            line: 498,
            column: 51
          },
          end: {
            line: 498,
            column: 62
          }
        }],
        line: 498
      },
      '36': {
        loc: {
          start: {
            line: 500,
            column: 10
          },
          end: {
            line: 500,
            column: 111
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 500,
            column: 21
          },
          end: {
            line: 500,
            column: 102
          }
        }, {
          start: {
            line: 500,
            column: 106
          },
          end: {
            line: 500,
            column: 111
          }
        }],
        line: 500
      },
      '37': {
        loc: {
          start: {
            line: 500,
            column: 40
          },
          end: {
            line: 500,
            column: 101
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 500,
            column: 54
          },
          end: {
            line: 500,
            column: 75
          }
        }, {
          start: {
            line: 500,
            column: 78
          },
          end: {
            line: 500,
            column: 101
          }
        }],
        line: 500
      },
      '38': {
        loc: {
          start: {
            line: 504,
            column: 17
          },
          end: {
            line: 504,
            column: 39
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 504,
            column: 27
          },
          end: {
            line: 504,
            column: 31
          }
        }, {
          start: {
            line: 504,
            column: 34
          },
          end: {
            line: 504,
            column: 39
          }
        }],
        line: 504
      },
      '39': {
        loc: {
          start: {
            line: 519,
            column: 6
          },
          end: {
            line: 521,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 519,
            column: 6
          },
          end: {
            line: 521,
            column: 7
          }
        }, {
          start: {
            line: 519,
            column: 6
          },
          end: {
            line: 521,
            column: 7
          }
        }],
        line: 519
      },
      '40': {
        loc: {
          start: {
            line: 522,
            column: 6
          },
          end: {
            line: 524,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 522,
            column: 6
          },
          end: {
            line: 524,
            column: 7
          }
        }, {
          start: {
            line: 522,
            column: 6
          },
          end: {
            line: 524,
            column: 7
          }
        }],
        line: 522
      },
      '41': {
        loc: {
          start: {
            line: 526,
            column: 6
          },
          end: {
            line: 528,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 526,
            column: 6
          },
          end: {
            line: 528,
            column: 7
          }
        }, {
          start: {
            line: 526,
            column: 6
          },
          end: {
            line: 528,
            column: 7
          }
        }],
        line: 526
      },
      '42': {
        loc: {
          start: {
            line: 529,
            column: 6
          },
          end: {
            line: 531,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 529,
            column: 6
          },
          end: {
            line: 531,
            column: 7
          }
        }, {
          start: {
            line: 529,
            column: 6
          },
          end: {
            line: 531,
            column: 7
          }
        }],
        line: 529
      },
      '43': {
        loc: {
          start: {
            line: 532,
            column: 6
          },
          end: {
            line: 534,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 532,
            column: 6
          },
          end: {
            line: 534,
            column: 7
          }
        }, {
          start: {
            line: 532,
            column: 6
          },
          end: {
            line: 534,
            column: 7
          }
        }],
        line: 532
      },
      '44': {
        loc: {
          start: {
            line: 532,
            column: 10
          },
          end: {
            line: 532,
            column: 40
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 532,
            column: 10
          },
          end: {
            line: 532,
            column: 23
          }
        }, {
          start: {
            line: 532,
            column: 27
          },
          end: {
            line: 532,
            column: 40
          }
        }],
        line: 532
      },
      '45': {
        loc: {
          start: {
            line: 562,
            column: 8
          },
          end: {
            line: 564,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 562,
            column: 8
          },
          end: {
            line: 564,
            column: 9
          }
        }, {
          start: {
            line: 562,
            column: 8
          },
          end: {
            line: 564,
            column: 9
          }
        }],
        line: 562
      },
      '46': {
        loc: {
          start: {
            line: 580,
            column: 8
          },
          end: {
            line: 583,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 580,
            column: 8
          },
          end: {
            line: 583,
            column: 9
          }
        }, {
          start: {
            line: 580,
            column: 8
          },
          end: {
            line: 583,
            column: 9
          }
        }],
        line: 580
      },
      '47': {
        loc: {
          start: {
            line: 643,
            column: 14
          },
          end: {
            line: 645,
            column: 15
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 643,
            column: 14
          },
          end: {
            line: 645,
            column: 15
          }
        }, {
          start: {
            line: 643,
            column: 14
          },
          end: {
            line: 645,
            column: 15
          }
        }],
        line: 643
      },
      '48': {
        loc: {
          start: {
            line: 643,
            column: 18
          },
          end: {
            line: 643,
            column: 68
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 643,
            column: 18
          },
          end: {
            line: 643,
            column: 41
          }
        }, {
          start: {
            line: 643,
            column: 45
          },
          end: {
            line: 643,
            column: 68
          }
        }],
        line: 643
      },
      '49': {
        loc: {
          start: {
            line: 665,
            column: 13
          },
          end: {
            line: 665,
            column: 133
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 665,
            column: 13
          },
          end: {
            line: 665,
            column: 71
          }
        }, {
          start: {
            line: 665,
            column: 75
          },
          end: {
            line: 665,
            column: 133
          }
        }],
        line: 665
      },
      '50': {
        loc: {
          start: {
            line: 685,
            column: 19
          },
          end: {
            line: 685,
            column: 34
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 685,
            column: 19
          },
          end: {
            line: 685,
            column: 25
          }
        }, {
          start: {
            line: 685,
            column: 29
          },
          end: {
            line: 685,
            column: 34
          }
        }],
        line: 685
      },
      '51': {
        loc: {
          start: {
            line: 686,
            column: 6
          },
          end: {
            line: 690,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 686,
            column: 6
          },
          end: {
            line: 690,
            column: 7
          }
        }, {
          start: {
            line: 686,
            column: 6
          },
          end: {
            line: 690,
            column: 7
          }
        }],
        line: 686
      },
      '52': {
        loc: {
          start: {
            line: 686,
            column: 10
          },
          end: {
            line: 686,
            column: 32
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 686,
            column: 10
          },
          end: {
            line: 686,
            column: 19
          }
        }, {
          start: {
            line: 686,
            column: 23
          },
          end: {
            line: 686,
            column: 32
          }
        }],
        line: 686
      },
      '53': {
        loc: {
          start: {
            line: 697,
            column: 6
          },
          end: {
            line: 699,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 697,
            column: 6
          },
          end: {
            line: 699,
            column: 7
          }
        }, {
          start: {
            line: 697,
            column: 6
          },
          end: {
            line: 699,
            column: 7
          }
        }],
        line: 697
      },
      '54': {
        loc: {
          start: {
            line: 700,
            column: 6
          },
          end: {
            line: 702,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 700,
            column: 6
          },
          end: {
            line: 702,
            column: 7
          }
        }, {
          start: {
            line: 700,
            column: 6
          },
          end: {
            line: 702,
            column: 7
          }
        }],
        line: 700
      },
      '55': {
        loc: {
          start: {
            line: 704,
            column: 6
          },
          end: {
            line: 706,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 704,
            column: 6
          },
          end: {
            line: 706,
            column: 7
          }
        }, {
          start: {
            line: 704,
            column: 6
          },
          end: {
            line: 706,
            column: 7
          }
        }],
        line: 704
      },
      '56': {
        loc: {
          start: {
            line: 707,
            column: 6
          },
          end: {
            line: 709,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 707,
            column: 6
          },
          end: {
            line: 709,
            column: 7
          }
        }, {
          start: {
            line: 707,
            column: 6
          },
          end: {
            line: 709,
            column: 7
          }
        }],
        line: 707
      },
      '57': {
        loc: {
          start: {
            line: 710,
            column: 6
          },
          end: {
            line: 712,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 710,
            column: 6
          },
          end: {
            line: 712,
            column: 7
          }
        }, {
          start: {
            line: 710,
            column: 6
          },
          end: {
            line: 712,
            column: 7
          }
        }],
        line: 710
      },
      '58': {
        loc: {
          start: {
            line: 710,
            column: 10
          },
          end: {
            line: 710,
            column: 40
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 710,
            column: 10
          },
          end: {
            line: 710,
            column: 23
          }
        }, {
          start: {
            line: 710,
            column: 27
          },
          end: {
            line: 710,
            column: 40
          }
        }],
        line: 710
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0,
      '70': 0,
      '71': 0,
      '72': 0,
      '73': 0,
      '74': 0,
      '75': 0,
      '76': 0,
      '77': 0,
      '78': 0,
      '79': 0,
      '80': 0,
      '81': 0,
      '82': 0,
      '83': 0,
      '84': 0,
      '85': 0,
      '86': 0,
      '87': 0,
      '88': 0,
      '89': 0,
      '90': 0,
      '91': 0,
      '92': 0,
      '93': 0,
      '94': 0,
      '95': 0,
      '96': 0,
      '97': 0,
      '98': 0,
      '99': 0,
      '100': 0,
      '101': 0,
      '102': 0,
      '103': 0,
      '104': 0,
      '105': 0,
      '106': 0,
      '107': 0,
      '108': 0,
      '109': 0,
      '110': 0,
      '111': 0,
      '112': 0,
      '113': 0,
      '114': 0,
      '115': 0,
      '116': 0,
      '117': 0,
      '118': 0,
      '119': 0,
      '120': 0,
      '121': 0,
      '122': 0,
      '123': 0,
      '124': 0,
      '125': 0,
      '126': 0,
      '127': 0,
      '128': 0,
      '129': 0,
      '130': 0,
      '131': 0,
      '132': 0,
      '133': 0,
      '134': 0,
      '135': 0,
      '136': 0,
      '137': 0,
      '138': 0,
      '139': 0,
      '140': 0,
      '141': 0,
      '142': 0,
      '143': 0,
      '144': 0,
      '145': 0,
      '146': 0,
      '147': 0,
      '148': 0,
      '149': 0,
      '150': 0,
      '151': 0,
      '152': 0,
      '153': 0,
      '154': 0,
      '155': 0,
      '156': 0,
      '157': 0,
      '158': 0,
      '159': 0,
      '160': 0,
      '161': 0,
      '162': 0,
      '163': 0,
      '164': 0,
      '165': 0,
      '166': 0,
      '167': 0,
      '168': 0,
      '169': 0,
      '170': 0,
      '171': 0,
      '172': 0,
      '173': 0,
      '174': 0,
      '175': 0,
      '176': 0,
      '177': 0,
      '178': 0,
      '179': 0,
      '180': 0,
      '181': 0,
      '182': 0,
      '183': 0,
      '184': 0,
      '185': 0,
      '186': 0,
      '187': 0,
      '188': 0,
      '189': 0,
      '190': 0,
      '191': 0,
      '192': 0,
      '193': 0,
      '194': 0,
      '195': 0,
      '196': 0,
      '197': 0,
      '198': 0,
      '199': 0,
      '200': 0,
      '201': 0,
      '202': 0,
      '203': 0,
      '204': 0,
      '205': 0,
      '206': 0,
      '207': 0,
      '208': 0,
      '209': 0,
      '210': 0,
      '211': 0,
      '212': 0,
      '213': 0,
      '214': 0,
      '215': 0,
      '216': 0,
      '217': 0,
      '218': 0,
      '219': 0,
      '220': 0,
      '221': 0,
      '222': 0,
      '223': 0,
      '224': 0,
      '225': 0,
      '226': 0,
      '227': 0,
      '228': 0,
      '229': 0,
      '230': 0,
      '231': 0,
      '232': 0,
      '233': 0,
      '234': 0,
      '235': 0,
      '236': 0,
      '237': 0,
      '238': 0,
      '239': 0,
      '240': 0,
      '241': 0,
      '242': 0,
      '243': 0,
      '244': 0,
      '245': 0,
      '246': 0,
      '247': 0,
      '248': 0,
      '249': 0,
      '250': 0,
      '251': 0,
      '252': 0,
      '253': 0,
      '254': 0,
      '255': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0],
      '11': [0, 0],
      '12': [0, 0],
      '13': [0, 0],
      '14': [0, 0, 0],
      '15': [0, 0],
      '16': [0, 0],
      '17': [0, 0],
      '18': [0, 0],
      '19': [0, 0],
      '20': [0, 0],
      '21': [0, 0],
      '22': [0, 0],
      '23': [0, 0],
      '24': [0, 0],
      '25': [0, 0],
      '26': [0, 0],
      '27': [0, 0],
      '28': [0, 0],
      '29': [0, 0],
      '30': [0, 0],
      '31': [0, 0],
      '32': [0, 0],
      '33': [0, 0],
      '34': [0, 0],
      '35': [0, 0],
      '36': [0, 0],
      '37': [0, 0],
      '38': [0, 0],
      '39': [0, 0],
      '40': [0, 0],
      '41': [0, 0],
      '42': [0, 0],
      '43': [0, 0],
      '44': [0, 0],
      '45': [0, 0],
      '46': [0, 0],
      '47': [0, 0],
      '48': [0, 0],
      '49': [0, 0],
      '50': [0, 0],
      '51': [0, 0],
      '52': [0, 0],
      '53': [0, 0],
      '54': [0, 0],
      '55': [0, 0],
      '56': [0, 0],
      '57': [0, 0],
      '58': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _this = this;

cov_2kh2svqu60.s[0]++;
angular.module('app').controller('ProjectDashboardCtrl', function ($scope, $CRUDService, $deltaNumber, $deltadate, $rootScope, $translate, $filter, $LOGINService, $deltahttp, $deltaProjectStatus) {
  cov_2kh2svqu60.f[0]++;

  var PATH = (cov_2kh2svqu60.s[1]++, 'Milestone');
  var PATH_PROJECT = (cov_2kh2svqu60.s[2]++, 'Projet');
  var PATH_FINANCING = (cov_2kh2svqu60.s[3]++, 'Financement');
  var PATH_INDICATORS = (cov_2kh2svqu60.s[4]++, 'Indicateurs');
  var PATH_DOCUMENT = (cov_2kh2svqu60.s[5]++, 'Documents');
  var PATH_PHOTOTHEQUE = (cov_2kh2svqu60.s[6]++, 'Phototheque');
  var PATH_INDICATORS_GLOBAL = (cov_2kh2svqu60.s[7]++, 'IndicateursGlobal');
  var PATH_RISK = (cov_2kh2svqu60.s[8]++, 'Risk');


  var idProject = (cov_2kh2svqu60.s[9]++, $rootScope.projectDetail());

  cov_2kh2svqu60.s[10]++;
  $scope.entete = {
    page: 1
  };

  cov_2kh2svqu60.s[11]++;
  $scope.getProjectStatusLabel = function (id) {
    cov_2kh2svqu60.f[1]++;

    var status = (cov_2kh2svqu60.s[12]++, $deltaProjectStatus.getById(id));
    cov_2kh2svqu60.s[13]++;
    return status ? (cov_2kh2svqu60.b[0][0]++, status.name) : (cov_2kh2svqu60.b[0][1]++, '');
  };

  cov_2kh2svqu60.s[14]++;
  $scope.listImpact = [{ id: 1, name: $translate.instant('RISK.IMPACTS.HIGH') }, { id: 2, name: $translate.instant('RISK.IMPACTS.MEDIUM') }, { id: 3, name: $translate.instant('RISK.IMPACTS.LOW') }];

  cov_2kh2svqu60.s[15]++;
  $scope.listStatus = [{ id: 1, name: $translate.instant('RISK.STATUS_LIST.UNRESOLVED') }, { id: 2, name: $translate.instant('RISK.STATUS_LIST.IN_PROGRESS') }, { id: 3, name: $translate.instant('RISK.STATUS_LIST.RESOLVED') }];

  cov_2kh2svqu60.s[16]++;
  $scope.isYoutube = function (el) {
    cov_2kh2svqu60.f[2]++;
    cov_2kh2svqu60.s[17]++;

    return true;
  };
  cov_2kh2svqu60.s[18]++;
  $scope.getVideoId = function (el) {
    cov_2kh2svqu60.f[3]++;

    var list = (cov_2kh2svqu60.s[19]++, []);
    cov_2kh2svqu60.s[20]++;
    if (!this.isYoutube(el)) {
      cov_2kh2svqu60.b[1][0]++;
      cov_2kh2svqu60.s[21]++;

      list = ((cov_2kh2svqu60.b[2][0]++, el.URL_VIDEO) || (cov_2kh2svqu60.b[2][1]++, '')).split('/');
      cov_2kh2svqu60.s[22]++;
      return list[list.length - 1];
    } else {
      cov_2kh2svqu60.b[1][1]++;
    }
    cov_2kh2svqu60.s[23]++;
    list = ((cov_2kh2svqu60.b[3][0]++, el.URL_VIDEO) || (cov_2kh2svqu60.b[3][1]++, '')).split('?');
    cov_2kh2svqu60.s[24]++;
    if (list.length == 1) {
      cov_2kh2svqu60.b[4][0]++;
      cov_2kh2svqu60.s[25]++;

      list = ((cov_2kh2svqu60.b[5][0]++, el.URL_VIDEO) || (cov_2kh2svqu60.b[5][1]++, '')).split('/');
    } else {
      cov_2kh2svqu60.b[4][1]++;
    }

    var params = (cov_2kh2svqu60.s[26]++, ((cov_2kh2svqu60.b[6][0]++, list[list.length - 1]) || (cov_2kh2svqu60.b[6][1]++, '')).split('&'));

    cov_2kh2svqu60.s[27]++;
    return ((cov_2kh2svqu60.b[7][0]++, params[0]) || (cov_2kh2svqu60.b[7][1]++, '')).replace('v=', '');
  };

  cov_2kh2svqu60.s[28]++;
  $CRUDService.getAll(PATH_PROJECT, { get: 'single', id: idProject }, function (data) {
    cov_2kh2svqu60.f[4]++;
    cov_2kh2svqu60.s[29]++;

    if (data.length <= 0) {
      cov_2kh2svqu60.b[8][0]++;
      cov_2kh2svqu60.s[30]++;

      _this.isloading = false;
      cov_2kh2svqu60.s[31]++;
      return;
    } else {
      cov_2kh2svqu60.b[8][1]++;
    }
    cov_2kh2svqu60.s[32]++;
    for (var i = 0; i < data.length; i++) {
      cov_2kh2svqu60.s[33]++;

      if (!data[i].DATE_DEB_PROJET) {
        cov_2kh2svqu60.b[9][0]++;
        cov_2kh2svqu60.s[34]++;

        continue;
      } else {
        cov_2kh2svqu60.b[9][1]++;
      }
      cov_2kh2svqu60.s[35]++;
      data[i].DATE_DEB_PROJET = Date.newDate(data[i].DATE_DEB_PROJET);
      cov_2kh2svqu60.s[36]++;
      data[i].COUT = parseFloat(data[i].COUT);
      cov_2kh2svqu60.s[37]++;
      data[i].STATUT_BUDGET = parseInt(data[i].STATUT_BUDGET, 10) === 1;
      cov_2kh2svqu60.s[38]++;
      data[i].DATE_FIN_PROJET = Date.newDate(data[i].DATE_FIN_PROJET);
      cov_2kh2svqu60.s[39]++;
      data[i].DATE_MI_PRO = Date.newDate((cov_2kh2svqu60.b[10][0]++, data[i].DATE_MI_PRO) || (cov_2kh2svqu60.b[10][1]++, undefined));
      cov_2kh2svqu60.s[40]++;
      data[i].PAYS_PROJET = parseInt(data[i].PAYS_PROJET, 10);
      var zone = (cov_2kh2svqu60.s[41]++, []);
      cov_2kh2svqu60.s[42]++;
      for (var _iterator = Object.keys(data[i].LOCATION_FIELD), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var key = _ref;
        cov_2kh2svqu60.s[43]++;

        zone.push(data[i].LOCATION_FIELD[key]);
      }
      cov_2kh2svqu60.s[44]++;
      data[i].LOCATION_FIELD = zone.join(' , ');
      cov_2kh2svqu60.s[45]++;
      $scope.selectProject = data[i];
    }
  });

  cov_2kh2svqu60.s[46]++;

  $CRUDService.getAll(PATH_FINANCING, { get: 'state', id: idProject }, function (data) {
    cov_2kh2svqu60.f[5]++;
    cov_2kh2svqu60.s[47]++;

    data = data.map(function (value) {
      cov_2kh2svqu60.f[6]++;
      cov_2kh2svqu60.s[48]++;

      value.AMOUNT_AFF = $filter('number')(value.AMOUNT);
      cov_2kh2svqu60.s[49]++;
      value.DISBURSED_AFF = $filter('number')(value.DISBURSED);
      cov_2kh2svqu60.s[50]++;
      value.SOLD_AFF = $filter('number')(value.SOLD);
      cov_2kh2svqu60.s[51]++;
      return value;
    });

    cov_2kh2svqu60.s[52]++;
    $scope.financingState = angular.copy(data);
    cov_2kh2svqu60.s[53]++;
    $scope.financialParams = {
      dataSource: data,
      gridLines: 'Both',
      columns: [{ field: 'LIBELLE_FIN', headerText: $translate.instant('PROJECT.DASHBOARD_VIEW.FINANCING').toUpperCase() }, { field: 'AMOUNT_AFF', headerText: $translate.instant('PROJECT.DASHBOARD_VIEW.AMOUNT').toUpperCase() + ' (' + $rootScope.getGlobalCurrency() + ')', width: 200, textAlign: 'Right' }, { field: 'DISBURSED_AFF', headerText: $translate.instant('PROJECT.DASHBOARD_VIEW.DISBURSED').toUpperCase() + ' (' + $rootScope.getGlobalCurrency() + ')', width: 200, textAlign: 'Right' }, { field: 'SOLD_AFF', headerText: $translate.instant('PROJECT.DASHBOARD_VIEW.SOLD').toUpperCase() + ' (' + $rootScope.getGlobalCurrency() + ')', width: 200, textAlign: 'Right' }],
      allowSelection: false,
      width: 'auto',
      height: 'auto',
      allowTextWrap: true
    };

    cov_2kh2svqu60.s[54]++;

    $scope.financingStateChart = {
      series: [{
        type: 'Pie', dataSource: data.map(function (value) {
          cov_2kh2svqu60.f[7]++;
          cov_2kh2svqu60.s[55]++;

          return {
            value: value.DISBURSED ? (cov_2kh2svqu60.b[11][0]++, Math.round(value.DISBURSED)) : (cov_2kh2svqu60.b[11][1]++, null),
            name: value.LIBELLE_FIN
          };
        }).filter(function (item) {
          cov_2kh2svqu60.f[8]++;
          cov_2kh2svqu60.s[56]++;

          return item.value != null;
        }), xName: 'name', yName: 'value',
        dataLabel: { visible: true, position: 'Outside' } }], textRender: function textRender(args) {
        cov_2kh2svqu60.s[57]++;

        if (!args.extraData) {
          cov_2kh2svqu60.b[12][0]++;
          cov_2kh2svqu60.s[58]++;

          args.extraData = $filter('number')(args.text);
        } else {
          cov_2kh2svqu60.b[12][1]++;
        }
        cov_2kh2svqu60.s[59]++;
        args.text = args.extraData + ' ' + $rootScope.getGlobalCurrency();
      },

      legendSettings: { visible: true, position: 'Bottom' }, enableSmartLabels: true,
      title: $translate.instant('PROJECT.DASHBOARD_VIEW.TOTAL_DISBURSED_BY_FUNDING').toUpperCase(),

      tooltip: { enable: true, format: '${point.x} <br> ${point.percentage} %' },
      width: '100%',
      height: '100%'
    };
  });

  cov_2kh2svqu60.s[60]++;

  $CRUDService.getAll(PATH_FINANCING, { get: 'state_chart', id: idProject }, function (data) {
    cov_2kh2svqu60.f[9]++;
    cov_2kh2svqu60.s[61]++;

    $scope.financingState = data;
    cov_2kh2svqu60.s[62]++;

    $scope.financingStateChartProgress = {
      locale: $LOGINService.getLang(),

      primaryXAxis: {
        interval: 1,
        labelIntersectAction: 'Rotate45',
        valueType: 'Category',
        majorGridLines: { width: 0 }, minorGridLines: { width: 0 },
        majorTickLines: { width: 0 }, minorTickLines: { width: 0 },
        lineStyle: { width: 0 }
      },
      primaryYAxis: {
        valueType: 'Double',
        lineStyle: { width: 0 },
        majorTickLines: { width: 0 }, majorGridLines: { width: 1 },
        minorGridLines: { width: 1 }, minorTickLines: { width: 0 },
        labelFormat: 'P'
      },
      chartArea: {
        border: {
          width: 0
        }
      },
      useGroupingSeparator: true,

      series: [{
        type: 'Line',
        opacity: 0.5,
        dataSource: data,

        fill: 'rgba(0, 15, 62, 0.7)',
        xName: 'YEAR', yName: 'RATE',
        width: 3,
        marker: {
          visible: true,
          width: 10,
          height: 10
        }
      }],
      height: 'calc(100% - 20px)',
      width: '100%',

      title: $translate.instant('PROJECT.DASHBOARD_VIEW.DISBURSED_RATE').toUpperCase(),

      legendSettings: {
        visible: false
      },

      tooltip: { enable: true, shared: false }
    };
  });

  cov_2kh2svqu60.s[63]++;

  $CRUDService.getAll(PATH_INDICATORS, { get: 'frameres_standard', p_bksb_: idProject, idl: 0, idcl: 0 }, function (data) {
    cov_2kh2svqu60.f[10]++;

    var labels = (cov_2kh2svqu60.s[64]++, []);
    cov_2kh2svqu60.s[65]++;
    for (var key in data.cl) {
      cov_2kh2svqu60.s[66]++;

      data.cl[key].id = key;
      cov_2kh2svqu60.s[67]++;
      labels.push(data.cl[key]);
    }

    var finalData = (cov_2kh2svqu60.s[68]++, []);

    cov_2kh2svqu60.s[69]++;
    labels.sort(function (a, b) {
      cov_2kh2svqu60.f[11]++;
      cov_2kh2svqu60.s[70]++;

      return a.CODE > b.CODE ? (cov_2kh2svqu60.b[13][0]++, 1) : (cov_2kh2svqu60.b[13][1]++, -1);
    });

    cov_2kh2svqu60.s[71]++;

    var _loop = function _loop() {
      if (_isArray2) {
        if (_i2 >= _iterator2.length) return 'break';
        _ref2 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) return 'break';
        _ref2 = _i2.value;
      }

      var cl = _ref2;

      var items = (cov_2kh2svqu60.s[72]++, data.d.filter(function (indicator) {
        cov_2kh2svqu60.f[12]++;
        cov_2kh2svqu60.s[73]++;

        return (cov_2kh2svqu60.b[14][0]++, indicator.idcl == cl.id) && ((cov_2kh2svqu60.b[14][1]++, indicator.t == 1) || (cov_2kh2svqu60.b[14][2]++, indicator.t == 2));
      }));
      cov_2kh2svqu60.s[74]++;
      if (items.length > 0) {
        cov_2kh2svqu60.b[15][0]++;
        cov_2kh2svqu60.s[75]++;

        finalData.push({ li: ' <h4 class="font-bold"  >\n                      <span>' + cl.NIV_LABEL + '</span> : <span class="label label-primary  m-r-xs" style=" background-color: rgba(' + cl.COLOR + ',0.9);">\n                          ' + cl.CODE_AFF + '\n                      </span> ' + cl.LABEL + '\n                    </h3>', header: true });
      } else {
        cov_2kh2svqu60.b[15][1]++;
      }
      cov_2kh2svqu60.s[76]++;
      for (var _iterator3 = items, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
        var _ref3;

        if (_isArray3) {
          if (_i3 >= _iterator3.length) break;
          _ref3 = _iterator3[_i3++];
        } else {
          _i3 = _iterator3.next();
          if (_i3.done) break;
          _ref3 = _i3.value;
        }

        var el = _ref3;
        cov_2kh2svqu60.s[77]++;

        el.vra = $deltaNumber.formatNumberToString(el.vr, el.fo, null);
        cov_2kh2svqu60.s[78]++;
        el.vca = $deltaNumber.formatNumberToString(el.vc, el.fo, null);
        cov_2kh2svqu60.s[79]++;
        el.actual = $deltaNumber.formatNumberToString(el.actual, el.fo, null);

        cov_2kh2svqu60.s[80]++;
        finalData.push({
          li: '<span class="font-bold" >\n                        <span class="label label-primary  m-r-xs text-left" style="background-color: rgba(' + el.co + ',0.9); color: rgba(' + el.co + ',0.9); padding:0; width: 10px; display: inline-block;">\n                          A\n                        </span> ' + el.in + '\n                    </span>',
          cu: el.cu,
          sl: '<span style="font-size: 10px" class="font-bold">' + $translate.instant('FRAME_RESULT.VALUE') + '</span>',
          vra: el.vra,
          vca: el.vca,
          actual: el.actual
        });
        cov_2kh2svqu60.s[81]++;
        finalData.push({
          sl: '<span style="font-size: 10px" class="font-bold">' + $translate.instant('FRAME_RESULT.DATE') + '</span>',
          vra: el.begin ? (cov_2kh2svqu60.b[16][0]++, $filter('date')(el.begin)) : (cov_2kh2svqu60.b[16][1]++, ''),
          vca: el.actualD ? (cov_2kh2svqu60.b[17][0]++, $filter('date')(el.actualD)) : (cov_2kh2svqu60.b[17][1]++, ''),
          actual: el.end ? (cov_2kh2svqu60.b[18][0]++, $filter('date')(el.end)) : (cov_2kh2svqu60.b[18][1]++, '')
        });
        cov_2kh2svqu60.s[82]++;
        finalData.push({
          sl: '<span style="font-size: 10px" class="font-bold">' + $translate.instant('FRAME_RESULT.COMMENT') + '</span>',
          comment: true,
          vra: el.comment
        });
      }
    };

    for (var _iterator2 = labels, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref2;

      var _ret = _loop();

      if (_ret === 'break') break;
    }

    cov_2kh2svqu60.s[83]++;
    $scope.params = {

      dataSource: finalData,
      queryCellInfo: function queryCellInfo(args) {
        var data = (cov_2kh2svqu60.s[84]++, args.data);
        cov_2kh2svqu60.s[85]++;
        if (data.header) {
          cov_2kh2svqu60.b[19][0]++;
          cov_2kh2svqu60.s[86]++;

          args.colSpan = 6;
          cov_2kh2svqu60.s[87]++;
          return;
        } else {
          cov_2kh2svqu60.b[19][1]++;
        }

        cov_2kh2svqu60.s[88]++;
        if ((cov_2kh2svqu60.b[21][0]++, args.column.field === 'li') && (cov_2kh2svqu60.b[21][1]++, data.li)) {
          cov_2kh2svqu60.b[20][0]++;
          cov_2kh2svqu60.s[89]++;

          args.rowSpan = 3;
        } else {
          cov_2kh2svqu60.b[20][1]++;
        }

        cov_2kh2svqu60.s[90]++;
        if ((cov_2kh2svqu60.b[23][0]++, args.column.field === 'vra') && (cov_2kh2svqu60.b[23][1]++, data.comment)) {
          cov_2kh2svqu60.b[22][0]++;
          cov_2kh2svqu60.s[91]++;

          args.colSpan = 3;
        } else {
          cov_2kh2svqu60.b[22][1]++;
        }

        cov_2kh2svqu60.s[92]++;
        if ((cov_2kh2svqu60.b[25][0]++, args.column.field === 'cu') && (cov_2kh2svqu60.b[25][1]++, data.cu)) {
          cov_2kh2svqu60.b[24][0]++;
          cov_2kh2svqu60.s[93]++;

          args.rowSpan = 3;
        } else {
          cov_2kh2svqu60.b[24][1]++;
        }
      },

      gridLines: 'Both',
      allowSelection: false,
      columns: [{ field: 'li', headerText: $translate.instant('FRAME_RESULT.INDIC').toUpperCase(), disableHtmlEncode: false }, { field: 'cu', headerText: $translate.instant('FRAME_RESULT.UNIT').toUpperCase(), width: 120, autoFit: true }, { field: 'sl', headerText: '', disableHtmlEncode: false, autoFit: true }, { field: 'vra', headerText: $translate.instant('INDICATOR.REF').toUpperCase(), width: 120 }, { field: 'actual', headerText: $translate.instant('FRAME_RESULT.ACTUAL').toUpperCase(), width: 120, textAlign: 'Center' }, { field: 'vca', headerText: $translate.instant('FRAME_RESULT.TARGET').toUpperCase(), width: 120 }],
      width: 'auto',
      height: $('body').height() - 330 + 'px',
      allowTextWrap: true
    };
  });

  cov_2kh2svqu60.s[94]++;

  $CRUDService.getAll(PATH_INDICATORS, { get: 'frameres', valid: 0, idl: 0, idcl: 0, p_bksb_: idProject }, function (data) {
    cov_2kh2svqu60.f[13]++;
    cov_2kh2svqu60.s[95]++;

    $scope.frameresultParams = {
      queryCellInfo: function queryCellInfo(args) {
        var data = (cov_2kh2svqu60.s[96]++, args.data);
        cov_2kh2svqu60.s[97]++;
        if ((cov_2kh2svqu60.b[27][0]++, data.cols) && (cov_2kh2svqu60.b[27][1]++, args.column.field == 'li_')) {
          cov_2kh2svqu60.b[26][0]++;
          cov_2kh2svqu60.s[98]++;

          args.colSpan = data.cols;
        } else {
          cov_2kh2svqu60.b[26][1]++;
        }
      },
      recordClick: function recordClick(item) {
        cov_2kh2svqu60.s[99]++;

        if ($scope.frameresultParams.fromButton) {
          cov_2kh2svqu60.b[28][0]++;
          cov_2kh2svqu60.s[100]++;

          $scope.frameresultParams.openChart(item, {});
        } else {
          cov_2kh2svqu60.b[28][1]++;
        }
        cov_2kh2svqu60.s[101]++;
        $scope.frameresultParams.fromButton = false;
      },
      openChart: function openChart(item, event) {
        cov_2kh2svqu60.s[102]++;

        if (item.sub) {
          cov_2kh2svqu60.b[29][0]++;
          cov_2kh2svqu60.s[103]++;

          return;
        } else {
          cov_2kh2svqu60.b[29][1]++;
        }
        cov_2kh2svqu60.s[104]++;
        $scope.frameresultParams.grapheType = true;

        var table = (cov_2kh2svqu60.s[105]++, $('body'));

        cov_2kh2svqu60.s[106]++;
        $scope.frameresultParams.panelPosition = Object.assign({ top: 20, left: 20 }, {
          width: table.width() - 300 + 'px',
          height: table.height() - 300 + 'px'
        });
        cov_2kh2svqu60.s[107]++;
        $scope.frameresultParams.panelPosition.top = $scope.frameresultParams.panelPosition.top + 100 + 'px';
        cov_2kh2svqu60.s[108]++;
        $scope.frameresultParams.panelPosition.left = $scope.frameresultParams.panelPosition.left + 100 + 'px';

        cov_2kh2svqu60.s[109]++;
        $scope.frameresultParams.graphLabel = item.ci + ': ' + item.li;
        cov_2kh2svqu60.s[110]++;
        if ($scope.frameresultParams.lastindex == item.id) {
          cov_2kh2svqu60.b[30][0]++;
          cov_2kh2svqu60.s[111]++;

          $scope.frameresultParams.lastindex = null;
          cov_2kh2svqu60.s[112]++;
          return;
        } else {
          cov_2kh2svqu60.b[30][1]++;
        }
        cov_2kh2svqu60.s[113]++;
        $scope.frameresultParams.lastindex = item.id;
        var cible = (cov_2kh2svqu60.s[114]++, item.vc);
        var ref = (cov_2kh2svqu60.s[115]++, item.vr);
        var color = (cov_2kh2svqu60.s[116]++, $rootScope.personalData);
        var params = (cov_2kh2svqu60.s[117]++, {
          chartMouseClick: function chartMouseClick(args, a, b, c) {},

          primaryXAxis: {
            title: '',
            interval: 1,
            labelIntersectAction: 'Rotate45',
            valueType: 'Category',
            majorGridLines: { width: 0 }, minorGridLines: { width: 0 },
            majorTickLines: { width: 0 }, minorTickLines: { width: 0 }
          },

          primaryYAxis: {
            title: '',
            valueType: 'Double',
            labelFormat: 'N' + item.fo
          },
          chartArea: {
            border: {
              width: 1
            }
          },
          title: item.ci + ': ' + item.li,

          series: [{
            type: 'Column',
            fill: '#efe4b0',
            dataSource: [],
            xName: 'x', yName: 'y', name: $translate.instant('INDICATOR.TARGET_VAL')
          }, {
            fill: 'rgba(' + color.rframeVD + ',0.5)',
            type: 'Line',
            dataSource: [],
            xName: 'x', yName: 'y', name: $translate.instant('INDICATOR.REAL_VAL'),
            width: 2,
            marker: {
              visible: true,
              width: 10,
              height: 10
            }
          }, {
            fill: 'rgba(' + color.rframeVC + ',0.5)',
            type: 'Line',
            dataSource: [],
            xName: 'x', yName: 'y', name: $translate.instant('INDICATOR.TARGET'),
            width: 2,
            marker: {
              visible: true,
              width: 10,
              height: 10
            }
          }],

          height: $scope.frameresultParams.panelPosition.height,
          width: $scope.frameresultParams.panelPosition.width,
          tooltip: {
            enable: true
          }

        });

        cov_2kh2svqu60.s[118]++;
        params.series[0].dataSource.push({
          x: $translate.instant('INDICATOR.REF'),
          y: null
        });
        cov_2kh2svqu60.s[119]++;
        params.series[1].dataSource.push({
          x: $translate.instant('INDICATOR.REF'),
          y: ref
        });
        cov_2kh2svqu60.s[120]++;
        params.series[2].dataSource.push({
          x: $translate.instant('INDICATOR.REF'),
          y: null
        });
        cov_2kh2svqu60.s[121]++;
        for (var _iterator4 = this.years, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
          var _ref4;

          if (_isArray4) {
            if (_i4 >= _iterator4.length) break;
            _ref4 = _iterator4[_i4++];
          } else {
            _i4 = _iterator4.next();
            if (_i4.done) break;
            _ref4 = _i4.value;
          }

          var el = _ref4;
          cov_2kh2svqu60.s[122]++;

          params.series[0].dataSource.push({
            x: el,
            y: $deltaNumber.formatNumber(item['P' + el])
          });
          cov_2kh2svqu60.s[123]++;
          params.series[1].dataSource.push({
            x: el,
            y: $deltaNumber.formatNumber(item[el])
          });
          cov_2kh2svqu60.s[124]++;
          params.series[2].dataSource.push({
            x: el,
            y: null
          });
        }
        cov_2kh2svqu60.s[125]++;
        params.series[0].dataSource.push({
          x: $translate.instant('FRAME_RESULT.TARGET'),
          y: null
        });
        cov_2kh2svqu60.s[126]++;
        params.series[1].dataSource.push({
          x: $translate.instant('FRAME_RESULT.TARGET'),
          y: null
        });
        cov_2kh2svqu60.s[127]++;
        params.series[2].dataSource.push({
          x: $translate.instant('FRAME_RESULT.TARGET'),
          y: cible
        });

        cov_2kh2svqu60.s[128]++;
        $scope.frameresultParams.dataChart = params;
      },
      closeChart: function closeChart(index) {
        cov_2kh2svqu60.s[129]++;

        $scope.frameresultParams.lastindex = null;
        cov_2kh2svqu60.s[130]++;
        $scope.frameresultParams.details = false;
      }
    };
    cov_2kh2svqu60.s[131]++;
    $scope.frameresultParams.height = $('body').height() - 330;

    cov_2kh2svqu60.s[132]++;

    data.y.sort();
    var years = (cov_2kh2svqu60.s[133]++, data.y);
    cov_2kh2svqu60.s[134]++;
    $scope.frameresultParams.years = years;
    var currentData = (cov_2kh2svqu60.s[135]++, []);
    var columns = (cov_2kh2svqu60.s[136]++, [{ field: 'li_', headerText: $translate.instant('FRAME_RESULT.INDIC').toUpperCase(), width: 500, disableHtmlEncode: false }, { field: 'cu', headerText: $translate.instant('FRAME_RESULT.UNIT').toUpperCase(), width: 120 }, { width: 60, commands: [{ buttonOption: { content: '', cssClass: 'e-flat e-small', click: function click(args) {
            cov_2kh2svqu60.s[137]++;

            $scope.frameresultParams.fromButton = true;
          },
          iconCss: 'fa text-success fa-line-chart' } }] }, { field: 'vr', headerText: $translate.instant('INDICATOR.REF').toUpperCase(), width: 120, textAlign: 'Right', format: 'N', type: 'number' }]);
    cov_2kh2svqu60.s[138]++;
    for (var _iterator5 = years, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
      var _ref5;

      if (_isArray5) {
        if (_i5 >= _iterator5.length) break;
        _ref5 = _iterator5[_i5++];
      } else {
        _i5 = _iterator5.next();
        if (_i5.done) break;
        _ref5 = _i5.value;
      }

      var year = _ref5;
      cov_2kh2svqu60.s[139]++;

      columns.push({ headerText: year, autoFit: true, textAlign: 'Center', disableHtmlEncode: false, columns: [{ field: 'P' + year, headerText: $translate.instant('INDICATOR.TARGET_VAL'), textAlign: 'Right', format: 'N', type: 'number', width: 120, minWidth: 10 }, { field: year, headerText: $translate.instant('INDICATOR.REAL_VAL'), textAlign: 'Right', width: 120, minWidth: 10, format: 'N', type: 'number' }] });
    }
    cov_2kh2svqu60.s[140]++;
    columns.push({ field: 'vc', headerText: $translate.instant('FRAME_RESULT.FINAL_TARGET').toUpperCase(), width: 120, textAlign: 'Right', format: 'N', type: 'number' });
    cov_2kh2svqu60.s[141]++;

    columns[0].width = 300;
    cov_2kh2svqu60.s[142]++;
    $scope.frameresultParams.columns = angular.copy(columns);

    cov_2kh2svqu60.s[143]++;

    for (var _iterator6 = angular.copy(data.d), _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;) {
      var _ref6;

      if (_isArray6) {
        if (_i6 >= _iterator6.length) break;
        _ref6 = _iterator6[_i6++];
      } else {
        _i6 = _iterator6.next();
        if (_i6.done) break;
        _ref6 = _i6.value;
      }

      var el = _ref6;
      cov_2kh2svqu60.s[144]++;

      el.li_ = '<span class="label label-primary  m-r-xs text-left" style="background-color: rgba(' + el.co + ',0.9); color: rgba(' + el.co + ',0.9); padding:0; width: 10px; display: inline-block;">\n                          A\n                        </span> ' + ((cov_2kh2svqu60.b[31][0]++, el.ci_) || (cov_2kh2svqu60.b[31][1]++, el.ci)) + ': ' + el.li;
      cov_2kh2svqu60.s[145]++;
      if ((cov_2kh2svqu60.b[33][0]++, el.t == 1) || (cov_2kh2svqu60.b[33][1]++, el.t == 2)) {
        cov_2kh2svqu60.b[32][0]++;
        cov_2kh2svqu60.s[146]++;

        el.vr = $deltaNumber.formatNumber(el.vr, null, el.fo);
        cov_2kh2svqu60.s[147]++;
        el.vc = $deltaNumber.formatNumber(el.vc, null, el.fo);
        cov_2kh2svqu60.s[148]++;
        for (var _iterator7 = years, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _iterator7[Symbol.iterator]();;) {
          var _ref7;

          if (_isArray7) {
            if (_i7 >= _iterator7.length) break;
            _ref7 = _iterator7[_i7++];
          } else {
            _i7 = _iterator7.next();
            if (_i7.done) break;
            _ref7 = _i7.value;
          }

          var _year = _ref7;
          cov_2kh2svqu60.s[149]++;

          el[_year] = $deltaNumber.formatNumber(el[_year], null, el.fo);
          cov_2kh2svqu60.s[150]++;
          el['P' + _year] = $deltaNumber.formatNumber(el['P' + _year], null, el.fo);
        }
      } else {
        cov_2kh2svqu60.b[32][1]++;
      }
      var item = (cov_2kh2svqu60.s[151]++, angular.copy(el));
      cov_2kh2svqu60.s[152]++;
      item.d = undefined;
      cov_2kh2svqu60.s[153]++;
      currentData.push(item);
      cov_2kh2svqu60.s[154]++;
      for (var _iterator8 = el.d, _isArray8 = Array.isArray(_iterator8), _i8 = 0, _iterator8 = _isArray8 ? _iterator8 : _iterator8[Symbol.iterator]();;) {
        var _ref8;

        if (_isArray8) {
          if (_i8 >= _iterator8.length) break;
          _ref8 = _iterator8[_i8++];
        } else {
          _i8 = _iterator8.next();
          if (_i8.done) break;
          _ref8 = _i8.value;
        }

        var eld = _ref8;
        cov_2kh2svqu60.s[155]++;

        eld.cu = eld.tac ? (cov_2kh2svqu60.b[34][0]++, '') : (cov_2kh2svqu60.b[34][1]++, el.cu);
        cov_2kh2svqu60.s[156]++;
        eld.ci = el.ci;
        cov_2kh2svqu60.s[157]++;
        eld.li = el.li + ' (' + eld.tac ? (cov_2kh2svqu60.b[35][0]++, eld.id) : (cov_2kh2svqu60.b[35][1]++, eld.l + ')');
        cov_2kh2svqu60.s[158]++;
        eld.li_ = '<div class="m-l-lg"> <i class="fa fa-angle-double-right"></i> <i>' + (eld.tac ? (cov_2kh2svqu60.b[36][0]++, $translate.instant(eld.id == 1 ? (cov_2kh2svqu60.b[37][0]++, 'INDICATOR.NUMERATOR') : (cov_2kh2svqu60.b[37][1]++, 'INDICATOR.DENOMINATOR'))) : (cov_2kh2svqu60.b[36][1]++, eld.l)) + '</i></div>';
        cov_2kh2svqu60.s[159]++;
        eld.id = el.id;
        cov_2kh2svqu60.s[160]++;
        eld.sp = el.sp;
        cov_2kh2svqu60.s[161]++;
        eld.key = el.key;
        cov_2kh2svqu60.s[162]++;
        eld.fo = eld.tac ? (cov_2kh2svqu60.b[38][0]++, null) : (cov_2kh2svqu60.b[38][1]++, el.fo);
        cov_2kh2svqu60.s[163]++;
        eld.ti = el.ti;
        cov_2kh2svqu60.s[164]++;
        eld.so = el.so;
        cov_2kh2svqu60.s[165]++;
        eld.idcl = el.idcl;
        cov_2kh2svqu60.s[166]++;
        eld.option = 1;

        cov_2kh2svqu60.s[167]++;
        for (var _iterator9 = years, _isArray9 = Array.isArray(_iterator9), _i9 = 0, _iterator9 = _isArray9 ? _iterator9 : _iterator9[Symbol.iterator]();;) {
          var _ref9;

          if (_isArray9) {
            if (_i9 >= _iterator9.length) break;
            _ref9 = _iterator9[_i9++];
          } else {
            _i9 = _iterator9.next();
            if (_i9.done) break;
            _ref9 = _i9.value;
          }

          var _year2 = _ref9;
          cov_2kh2svqu60.s[168]++;

          eld[_year2] = $deltaNumber.formatNumber(eld[_year2], null, el.fo);
          cov_2kh2svqu60.s[169]++;
          eld['P' + _year2] = $deltaNumber.formatNumber(eld['P' + _year2], null, el.fo);
        }
        cov_2kh2svqu60.s[170]++;
        currentData.push(eld);
      }
    }

    cov_2kh2svqu60.s[171]++;
    currentData.sort(function (a, b) {
      cov_2kh2svqu60.f[14]++;
      cov_2kh2svqu60.s[172]++;

      if (a.ci > b.ci) {
        cov_2kh2svqu60.b[39][0]++;
        cov_2kh2svqu60.s[173]++;

        return 1;
      } else {
        cov_2kh2svqu60.b[39][1]++;
      }
      cov_2kh2svqu60.s[174]++;
      if (a.ci < b.ci) {
        cov_2kh2svqu60.b[40][0]++;
        cov_2kh2svqu60.s[175]++;

        return -1;
      } else {
        cov_2kh2svqu60.b[40][1]++;
      }

      cov_2kh2svqu60.s[176]++;
      if (a.id > b.id) {
        cov_2kh2svqu60.b[41][0]++;
        cov_2kh2svqu60.s[177]++;

        return 1;
      } else {
        cov_2kh2svqu60.b[41][1]++;
      }
      cov_2kh2svqu60.s[178]++;
      if (a.id < b.id) {
        cov_2kh2svqu60.b[42][0]++;
        cov_2kh2svqu60.s[179]++;

        return -1;
      } else {
        cov_2kh2svqu60.b[42][1]++;
      }
      cov_2kh2svqu60.s[180]++;
      if ((cov_2kh2svqu60.b[44][0]++, a.option != 1) && (cov_2kh2svqu60.b[44][1]++, b.option == 1)) {
        cov_2kh2svqu60.b[43][0]++;
        cov_2kh2svqu60.s[181]++;

        return -1;
      } else {
        cov_2kh2svqu60.b[43][1]++;
      }
      cov_2kh2svqu60.s[182]++;
      return 1;
    });

    var leveledData = (cov_2kh2svqu60.s[183]++, []);
    cov_2kh2svqu60.s[184]++;

    var _loop2 = function _loop2(levelKey) {
      var cl = (cov_2kh2svqu60.s[185]++, data.cl[levelKey]);
      cov_2kh2svqu60.s[186]++;
      cl.cols = 5 + $scope.frameresultParams.years.length * 2;
      cov_2kh2svqu60.s[187]++;
      cl.li_ = '<span>' + cl.NIV_LABEL + '</span>: <span class="label label-primary  m-r-xs" style=" background-color: rgba(' + cl.COLOR + ',0.9);">' + cl.CODE_AFF + '</span> - ' + cl.LABEL;
      cov_2kh2svqu60.s[188]++;
      leveledData.push(cl);
      cov_2kh2svqu60.s[189]++;
      for (var _iterator10 = currentData.filter(function (value) {
        cov_2kh2svqu60.f[15]++;
        cov_2kh2svqu60.s[190]++;

        return value.idcl == levelKey;
      }), _isArray10 = Array.isArray(_iterator10), _i10 = 0, _iterator10 = _isArray10 ? _iterator10 : _iterator10[Symbol.iterator]();;) {
        var _ref10;

        if (_isArray10) {
          if (_i10 >= _iterator10.length) break;
          _ref10 = _iterator10[_i10++];
        } else {
          _i10 = _iterator10.next();
          if (_i10.done) break;
          _ref10 = _i10.value;
        }

        var _item = _ref10;
        cov_2kh2svqu60.s[191]++;

        leveledData.push(_item);
      }
    };

    for (var levelKey in data.cl) {
      _loop2(levelKey);
    }

    cov_2kh2svqu60.s[192]++;
    $scope.frameresultParams.dataSource = leveledData;
  });

  cov_2kh2svqu60.s[193]++;

  $CRUDService.getAll(PATH_INDICATORS_GLOBAL, { get: 'frameres', valid: 0, idl: 0, idcl: 0, p_bksb_: idProject }, function (data) {
    cov_2kh2svqu60.f[16]++;
    cov_2kh2svqu60.s[194]++;

    $scope.frameresultParamsGlobal = {
      dataSource: null,
      recordClick: function recordClick(item) {
        cov_2kh2svqu60.s[195]++;

        if ($scope.frameresultParamsGlobal.fromButton) {
          cov_2kh2svqu60.b[45][0]++;
          cov_2kh2svqu60.s[196]++;

          $scope.frameresultParamsGlobal.openChart(item, {});
        } else {
          cov_2kh2svqu60.b[45][1]++;
        }
        cov_2kh2svqu60.s[197]++;
        $scope.frameresultParamsGlobal.fromButton = false;
      },
      openChart: function openChart(item, event) {
        cov_2kh2svqu60.s[198]++;

        $scope.frameresultParamsGlobal.grapheType = true;

        var table = (cov_2kh2svqu60.s[199]++, $('body'));

        cov_2kh2svqu60.s[200]++;
        $scope.frameresultParamsGlobal.panelPosition = Object.assign({ top: 20, left: 20 }, {
          width: table.width() - 300 + 'px',
          height: table.height() - 300 + 'px'
        });
        cov_2kh2svqu60.s[201]++;
        $scope.frameresultParamsGlobal.panelPosition.top = $scope.frameresultParamsGlobal.panelPosition.top + 100 + 'px';
        cov_2kh2svqu60.s[202]++;
        $scope.frameresultParamsGlobal.panelPosition.left = $scope.frameresultParamsGlobal.panelPosition.left + 100 + 'px';

        cov_2kh2svqu60.s[203]++;
        $scope.frameresultParamsGlobal.graphLabel = item.ci + ': ' + item.li;
        cov_2kh2svqu60.s[204]++;
        if ($scope.frameresultParamsGlobal.lastindex == item.id) {
          cov_2kh2svqu60.b[46][0]++;
          cov_2kh2svqu60.s[205]++;

          $scope.frameresultParamsGlobal.lastindex = null;
          cov_2kh2svqu60.s[206]++;
          return;
        } else {
          cov_2kh2svqu60.b[46][1]++;
        }
        cov_2kh2svqu60.s[207]++;
        $scope.frameresultParamsGlobal.lastindex = item.id;
        var color = (cov_2kh2svqu60.s[208]++, $rootScope.personalData);
        cov_2kh2svqu60.s[209]++;
        $scope.frameresultParamsGlobal.dataChart = null;
        cov_2kh2svqu60.s[210]++;
        $CRUDService.getAll(PATH_INDICATORS_GLOBAL, { get: 'tbhome_detail_period', valid: 0, idl: 0, idcl: 0, id: item.id, p_bksb_: idProject }, function (data_) {
          cov_2kh2svqu60.f[17]++;

          var params = (cov_2kh2svqu60.s[211]++, {
            chartMouseClick: function chartMouseClick(args, a, b, c) {},

            primaryXAxis: {
              title: '',
              interval: 1,
              labelIntersectAction: 'Rotate45',
              valueType: 'Category',
              majorGridLines: { width: 0 }, minorGridLines: { width: 0 },
              majorTickLines: { width: 0 }, minorTickLines: { width: 0 }
            },

            primaryYAxis: {
              title: '',
              valueType: 'Double',
              labelFormat: 'N' + item.fo
            },
            chartArea: {
              border: {
                width: 1
              }
            },
            title: item.ci + ': ' + item.li,

            series: [{
              fill: 'rgba(' + color.rframeVD + ',0.5)',
              type: 'Line',
              dataSource: [],
              xName: 'x', yName: 'y', name: $translate.instant('INDICATOR.REAL_VAL'),
              width: 2,
              marker: {
                visible: true,
                width: 10,
                height: 10
              }
            }],

            height: $scope.frameresultParamsGlobal.panelPosition.height,
            width: $scope.frameresultParamsGlobal.panelPosition.width,
            tooltip: {
              enable: true
            }

          });
          var beginProjet = (cov_2kh2svqu60.s[212]++, $deltadate.format($scope.selectProject.DATE_DEB_PROJET, 'yyyy-mm-dd'));
          var endProjet = (cov_2kh2svqu60.s[213]++, $deltadate.format($scope.selectProject.DATE_FIN_PROJET, 'yyyy-mm-dd'));
          cov_2kh2svqu60.s[214]++;
          for (var _iterator11 = data_, _isArray11 = Array.isArray(_iterator11), _i11 = 0, _iterator11 = _isArray11 ? _iterator11 : _iterator11[Symbol.iterator]();;) {
            var _ref11;

            if (_isArray11) {
              if (_i11 >= _iterator11.length) break;
              _ref11 = _iterator11[_i11++];
            } else {
              _i11 = _iterator11.next();
              if (_i11.done) break;
              _ref11 = _i11.value;
            }

            var line = _ref11;
            cov_2kh2svqu60.s[215]++;

            for (var _iterator12 = $deltadate.getPeriods(Date.newDate(line.begin), Date.newDate(line.end), item.PERIOD_INDIC), _isArray12 = Array.isArray(_iterator12), _i12 = 0, _iterator12 = _isArray12 ? _iterator12 : _iterator12[Symbol.iterator]();;) {
              var _ref12;

              if (_isArray12) {
                if (_i12 >= _iterator12.length) break;
                _ref12 = _iterator12[_i12++];
              } else {
                _i12 = _iterator12.next();
                if (_i12.done) break;
                _ref12 = _i12.value;
              }

              var yearLine = _ref12;

              var beginPeriod = (cov_2kh2svqu60.s[216]++, $deltadate.format(yearLine.begin, 'yyyy-mm-dd'));
              var endPeriod = (cov_2kh2svqu60.s[217]++, $deltadate.format(yearLine.end, 'yyyy-mm-dd'));
              cov_2kh2svqu60.s[218]++;
              if ((cov_2kh2svqu60.b[48][0]++, beginProjet > endPeriod) || (cov_2kh2svqu60.b[48][1]++, beginPeriod > endProjet)) {
                cov_2kh2svqu60.b[47][0]++;
                cov_2kh2svqu60.s[219]++;

                continue;
              } else {
                cov_2kh2svqu60.b[47][1]++;
              }
              cov_2kh2svqu60.s[220]++;
              params.series[0].dataSource.push({
                x: yearLine.label,
                y: $deltaNumber.formatNumber(line[yearLine.year.toString() + yearLine.index.toString()], null, line.fo)
              });
            }
          }
          cov_2kh2svqu60.s[221]++;
          $scope.frameresultParamsGlobal.dataChart = params;
        });
      },
      closeChart: function closeChart(index) {
        cov_2kh2svqu60.s[222]++;

        $scope.frameresultParamsGlobal.lastindex = null;
        cov_2kh2svqu60.s[223]++;
        $scope.frameresultParamsGlobal.details = false;
      }
    };
    cov_2kh2svqu60.s[224]++;
    $scope.frameresultParamsGlobal.height = $('body').height() - 330 + 'px';

    cov_2kh2svqu60.s[225]++;

    data.y.sort();
    var years = (cov_2kh2svqu60.s[226]++, data.y.filter(function (year) {
      cov_2kh2svqu60.f[18]++;
      cov_2kh2svqu60.s[227]++;

      return (cov_2kh2svqu60.b[49][0]++, year >= $scope.selectProject.DATE_DEB_PROJET.getFullYear()) && (cov_2kh2svqu60.b[49][1]++, year <= $scope.selectProject.DATE_FIN_PROJET.getFullYear());
    }));
    cov_2kh2svqu60.s[228]++;
    $scope.frameresultParamsGlobal.years = years;

    var columns = (cov_2kh2svqu60.s[229]++, [{ field: 'li_', headerText: $translate.instant('FRAME_RESULT.INDIC').toUpperCase(), width: 500 }, { field: 'cu', headerText: $translate.instant('FRAME_RESULT.UNIT').toUpperCase(), width: 120 }, { width: 60, commands: [{ buttonOption: { content: '', cssClass: 'e-flat e-small', click: function click(args) {
            cov_2kh2svqu60.s[230]++;

            $scope.frameresultParamsGlobal.fromButton = true;
          },
          iconCss: 'fa text-success fa-line-chart' } }] }]);
    cov_2kh2svqu60.s[231]++;
    for (var _iterator13 = years, _isArray13 = Array.isArray(_iterator13), _i13 = 0, _iterator13 = _isArray13 ? _iterator13 : _iterator13[Symbol.iterator]();;) {
      var _ref13;

      if (_isArray13) {
        if (_i13 >= _iterator13.length) break;
        _ref13 = _iterator13[_i13++];
      } else {
        _i13 = _iterator13.next();
        if (_i13.done) break;
        _ref13 = _i13.value;
      }

      var year = _ref13;
      cov_2kh2svqu60.s[232]++;

      columns.push({ field: year.toString(), headerText: year, textAlign: 'Right', width: 120, minWidth: 10, format: 'N', type: 'number' });
    }

    cov_2kh2svqu60.s[233]++;
    $scope.frameresultParamsGlobal.columns = angular.copy(columns);

    var currentData = (cov_2kh2svqu60.s[234]++, []);
    cov_2kh2svqu60.s[235]++;
    for (var _iterator14 = angular.copy(data.d), _isArray14 = Array.isArray(_iterator14), _i14 = 0, _iterator14 = _isArray14 ? _iterator14 : _iterator14[Symbol.iterator]();;) {
      var _ref14;

      if (_isArray14) {
        if (_i14 >= _iterator14.length) break;
        _ref14 = _iterator14[_i14++];
      } else {
        _i14 = _iterator14.next();
        if (_i14.done) break;
        _ref14 = _i14.value;
      }

      var el = _ref14;
      cov_2kh2svqu60.s[236]++;

      el.li_ = ' ' + ((cov_2kh2svqu60.b[50][0]++, el.ci_) || (cov_2kh2svqu60.b[50][1]++, el.ci)) + ': ' + el.li;
      cov_2kh2svqu60.s[237]++;
      if ((cov_2kh2svqu60.b[52][0]++, el.t == 1) || (cov_2kh2svqu60.b[52][1]++, el.t == 2)) {
        cov_2kh2svqu60.b[51][0]++;
        cov_2kh2svqu60.s[238]++;

        for (var _iterator15 = years, _isArray15 = Array.isArray(_iterator15), _i15 = 0, _iterator15 = _isArray15 ? _iterator15 : _iterator15[Symbol.iterator]();;) {
          var _ref15;

          if (_isArray15) {
            if (_i15 >= _iterator15.length) break;
            _ref15 = _iterator15[_i15++];
          } else {
            _i15 = _iterator15.next();
            if (_i15.done) break;
            _ref15 = _i15.value;
          }

          var _year3 = _ref15;
          cov_2kh2svqu60.s[239]++;

          el[_year3] = $deltaNumber.formatNumber(el[_year3], null, el.fo);
        }
      } else {
        cov_2kh2svqu60.b[51][1]++;
      }
      var item = (cov_2kh2svqu60.s[240]++, angular.copy(el));
      cov_2kh2svqu60.s[241]++;
      item.d = undefined;
      cov_2kh2svqu60.s[242]++;
      currentData.push(item);
    }

    cov_2kh2svqu60.s[243]++;
    currentData.sort(function (a, b) {
      cov_2kh2svqu60.f[19]++;
      cov_2kh2svqu60.s[244]++;

      if (a.ci > b.ci) {
        cov_2kh2svqu60.b[53][0]++;
        cov_2kh2svqu60.s[245]++;

        return 1;
      } else {
        cov_2kh2svqu60.b[53][1]++;
      }
      cov_2kh2svqu60.s[246]++;
      if (a.ci < b.ci) {
        cov_2kh2svqu60.b[54][0]++;
        cov_2kh2svqu60.s[247]++;

        return -1;
      } else {
        cov_2kh2svqu60.b[54][1]++;
      }

      cov_2kh2svqu60.s[248]++;
      if (a.id > b.id) {
        cov_2kh2svqu60.b[55][0]++;
        cov_2kh2svqu60.s[249]++;

        return 1;
      } else {
        cov_2kh2svqu60.b[55][1]++;
      }
      cov_2kh2svqu60.s[250]++;
      if (a.id < b.id) {
        cov_2kh2svqu60.b[56][0]++;
        cov_2kh2svqu60.s[251]++;

        return -1;
      } else {
        cov_2kh2svqu60.b[56][1]++;
      }
      cov_2kh2svqu60.s[252]++;
      if ((cov_2kh2svqu60.b[58][0]++, a.option != 1) && (cov_2kh2svqu60.b[58][1]++, b.option == 1)) {
        cov_2kh2svqu60.b[57][0]++;
        cov_2kh2svqu60.s[253]++;

        return -1;
      } else {
        cov_2kh2svqu60.b[57][1]++;
      }
      cov_2kh2svqu60.s[254]++;
      return 1;
    });
    cov_2kh2svqu60.s[255]++;
    $scope.frameresultParamsGlobal.dataSource = currentData;
  });
});